<template>
  <v-content>
    <v-card v-if="NoData" class="d-flex justify-center align-content-center" height="100%">
      <span style="font-weight: bold;font-size: 30px;margin-top: 250px;color: #ff6d81">
        ไม่พบข้อมูลโครงการ โปรดตรวจสอบ URL อีกครั้ง
      </span>
    </v-card>
    <v-card v-else-if="URLError" class="d-flex justify-center align-content-center" height="100%">
      <span style="font-weight: bold;font-size: 30px;margin-top: 250px;color: #ff6d81" v-if="projectData.length > 0">
        พบข้อผิดพลาด โปรดตรวจสอบ URL ลิงค์สำหรับการรับสมัครผู้เข้าร่วมโครงการ {{ projectData[0].Project_name }}
      </span>
    </v-card>
    <v-card v-else-if="NoRoundData" class="d-flex justify-center align-content-center" height="100%">
      <span style="font-weight: bold;font-size: 30px;margin-top: 250px;color: #ff6d81" v-if="projectData.length > 0">
        โครงการ {{ projectData[0].Project_name }} ไม่พบข้อมูลรุ่นในการจัดโครงการ โปรดติดต่อเจ้าของโครงการ!!
      </span>
    </v-card>
    <v-card v-if="projectData.length > 0 && projectData[0].Status_Reg == '1'"
            class="d-flex justify-center align-content-center" height="100%">
      <span style="font-weight: bold;font-size: 30px;margin-top: 250px;color: red" v-if="projectData.length > 0">
        โครงการ {{ projectData[0].Project_name }} ปิดการรับสมัคร
      </span>
    </v-card>
    <v-card
        v-else-if="projectData.length > 0 && ProjectRound.length == 0 && projectData[0].Status_Reg == '0' && projectData[0].Status_Type_Reg == '1'"
        class="d-flex justify-center align-content-center" height="100%">
      <span style="font-weight: bold;font-size: 30px;margin-top: 250px;color: red" v-if="projectData.length > 0">
        โครงการ {{ projectData[0].Project_name }} ไม่เปิดให้บุคลากรทั่วไปลงสมัคร
      </span>
    </v-card>
    <v-card
        v-else-if="projectData.length > 0 && ProjectRound.length > 0 && ProjectRound[0].Status_Reg == '0' && ProjectRound[0].Status_Type_Reg == '1'"
        class="d-flex justify-center align-content-center" height="100%">
      <span style="font-weight: bold;font-size: 30px;margin-top: 250px;color: red" v-if="projectData.length > 0">
        โครงการ {{ ProjectRound[0].Project_name }}  รุ่นที่ : {{ ProjectRound[0].Round }} {{
          ProjectRound[0].Round_name
        }} ไม่เปิดให้บุคลากรทั่วไปลงสมัคร
      </span>
    </v-card>
    <v-card v-else>
      <v-app-bar
          absolute
          color="#00695C"
          dark
          fixed
      >
        <v-spacer></v-spacer>

        <v-toolbar-title class="font-weight-bold text-md-h3 text-h4" v-if="projectData.length > 0">
          {{ projectData[0].Project_name }}
        </v-toolbar-title>

        <v-spacer></v-spacer>

      </v-app-bar>
      <v-card-text v-if="projectData.length > 0">
        <v-list class="mt-10">
          <v-list-item class="justify-center">
            <v-row class="d-flex justify-center">
              <v-col
                  cols="12"
                  md="8"
              >
                <v-list-item>
                  <span class="font-weight-bold text-md-h6">
              โครงการ : {{ projectData[0].Project_name }}
            </span>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                   <span class="font-weight-bold text-md-h6"
                         v-if="projectData[0].DateStart == projectData[0].DateEnd">
              {{
                       (projectData[0].IsRoundStatus == '1' && ProjectRound.length > 0 ? 'ช่วงวันที่จัดโครงการ' : 'วันที่จัดโครงการ')
                     }} : {{
                       projectData[0].DateStart | DateToThai
                     }} เวลา {{ projectData[0].Time_start }}
            </span>
                  <span class="font-weight-bold text-md-h6" v-else>
              {{
                      (projectData[0].IsRoundStatus == '1' && ProjectRound.length > 0 ? 'ช่วงวันที่จัดโครงการ' : 'วันที่จัดโครงการ')
                    }} : {{
                      projectData[0].DateStart | DateToThai
                    }} - {{ projectData[0].DateEnd | DateToThai }}
            </span>
                </v-list-item>
                <template v-if="projectData[0].IsRoundStatus == '1' && ProjectRound.length > 0">
                  <v-list-item v-for="(round,idx) in ProjectRound" :key="idx">
                  <span class="font-weight-bold text-md-h6" v-if="round.DateS == round.DateE">
                    รุ่นที่ : {{ round.Round }} {{ round.Round_name }} | วันที่จัด : {{ round.DateS | DateToThai }}
                  </span>
                    <span class="font-weight-bold text-md-h6" v-else>
                    รุ่นที่ : {{ round.Round }} {{ round.Round_name }} | วันที่จัด : {{
                        round.DateS | DateToThai
                      }} - {{ round.DateE | DateToThai }}
                  </span>
                  </v-list-item>
                </template>
                <v-divider></v-divider>
                <v-list-item>
                  <span class="font-weight-bold text-md-h6">
              สถานที่จัด : {{ projectData[0].Location }}
            </span>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                  <template v-if="projectData[0].IsRoundStatus == '1' && ProjectRound.length > 0">
                    <div v-for="(round,idx) in ProjectRound" :key="idx">
                       <span class="font-weight-bold text-md-h6"
                             v-if="round.DateS_Reg == round.DateE_Reg">
                        วันที่เปิดรับสมัคร : {{ round.DateS_Reg | DateToThai }}
                      </span>
                      <span class="font-weight-bold text-md-h6" v-else>
                        วันที่เปิดรับสมัคร : {{ round.DateS_Reg | DateToThai }} - {{ round.DateE_Reg | DateToThai }}
                      </span>
                    </div>
                  </template>
                  <template v-else>
                    <span class="font-weight-bold text-md-h6"
                          v-if="projectData[0].DateS_Reg == projectData[0].DateE_Reg">
              วันที่เปิดรับสมัคร : {{
                        projectData[0].DateS_Reg | DateToThai
                      }} จำนวนผู้เข้าร่วม {{
                        (projectData[0].Status_Count_Reg == '1' ? 'ไม่จำกัด' : projectData[0].Count_Reg + ' คน')
                      }}
            </span>
                    <span class="font-weight-bold text-md-h6" v-else>
              วันที่เปิดรับสมัคร : {{
                        projectData[0].DateS_Reg | DateToThai
                      }} - {{ projectData[0].DateE_Reg | DateToThai }}
            </span>
                  </template>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                  <template v-if="projectData[0].IsRoundStatus == '1' && ProjectRound.length > 0">
                    <div v-for="(round,idx) in ProjectRound" :key="idx">
                      <span class="font-weight-bold text-md-h6"> จำกัดผู้เข้าร่วม {{
                          (round.Status_Count_Reg == '1' ? 'ไม่จำกัด' : round.Count_Reg + ' คน')
                        }} </span>
                    </div>
                  </template>
                  <template v-else-if="projectData[0].IsRoundStatus == '0'">
                    <span class="font-weight-bold text-md-h6">
              จำกัดผู้เข้าร่วม : {{
                        (projectData[0].Status_Count_Reg == '1' ? 'ไม่จำกัด' : projectData[0].Count_Reg + ' คน')
                      }}
            </span>
                  </template>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                   <span class="font-weight-bold text-md-h6">
              เงื่อนไขการเข้าร่วมโครงการ :
                     <v-btn text color="primary" @click="ShowCordiProject">
                     Click!!
                   </v-btn>
            </span>
                </v-list-item>
              </v-col>
            </v-row>
          </v-list-item>
          <template v-if="projectData[0].IsRoundStatus == '1' && ProjectRound.length > 0">
            <div v-if="ProjectRound[0].DateE_Reg  >= formatDateNow()">
              <div align="center">
                      <span class="font-weight-bold text-md-h5" style="color: #42b983">
                        ส่งรายชื่อสมัครเข้าร่วมโครงการ
                      </span>
              </div>
              <v-list-item>
                <v-row class="d-flex justify-center">
                  <v-col
                      cols="12"
                      md="4">
                    <v-autocomplete
                        v-model="staffSel"
                        label="ค้นหาบุคลากร"
                        :items="staffDataDump"
                        item-text="customDetail"
                        item-value="perid"
                        hint="กด Enter เพื่อเป็นการเพิ่มข้อมูล"
                        persistent-hint
                        clearable
                        outlined
                        @keyup="checkKeyEnter"
                    ></v-autocomplete>
                  </v-col>
                  <v-col
                      cols="12"
                      md="2">
                    <v-file-input
                        v-model="files"
                        color="deep-purple accent-4"
                        counter
                        label="แนบไฟล์ (ถ้ามี)"
                        multiple
                        placeholder="เลือกไฟล์"
                        prepend-icon="mdi-paperclip"
                        outlined
                        :show-size="1000"
                        @change="FileSelect"
                    >
                      <template v-slot:selection="{ index, text }">
                        <v-chip
                            v-if="index < 5"
                            color="deep-purple accent-4"
                            dark
                            label
                            small
                        >
                          {{ text }}
                        </v-chip>

                        <span
                            v-else-if="index === 5"
                            class="overline grey--text text--darken-3 mx-2"
                        >
                                +{{ files.length - 2 }} File(s)
                              </span>
                      </template>
                    </v-file-input>
                  </v-col>
                </v-row>
              </v-list-item>
              <div align="center">
                <v-btn
                    class="mt-2"
                    outlined
                    color="primary"
                    @click="RequestRegister">
                  เพิ่ม
                </v-btn>
              </div>
              <v-list-item class="d-flex justify-center">
                <v-alert
                    v-if="alert"
                    prominent
                    type="error"
                >
                  <v-row align="center" v-for="item in txtAlert" :key="item.id">
                    <v-col class="d-flex grow">- {{ item.Detail }}</v-col>
                  </v-row>
                </v-alert>
              </v-list-item>
              <v-list-item v-if="FilePerson.length > 0">
                <template>
                  <v-row>
                    <v-col cols="12" sm="6" offset-sm="3">
                      <v-card>
                        <v-card-title>
                          ไฟล์ประกอบ
                        </v-card-title>
                        <v-container fluid>
                          <v-row>
                            <v-col
                                v-for="(file_i, index) in FilePerson"
                                :key="index"
                                class="d-flex child-flex"
                                cols="12"
                                md="4"
                            >
                              <v-card flat tile class="d-flex">
                                <v-img
                                    v-if="file_i.type == 'image'"
                                    :src="file_i.src"
                                    :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                                    aspect-ratio="1"
                                    class="grey lighten-2"
                                >
                                  <template v-slot:placeholder>
                                    <v-row
                                        class="fill-height ma-0"
                                        align="center"
                                        justify="center"
                                    >
                                      <v-progress-circular
                                          indeterminate
                                          color="grey lighten-5"></v-progress-circular>
                                    </v-row>
                                  </template>
                                </v-img>
                                <v-img
                                    v-else-if="file_i.type == 'pdf'"
                                    src="../assets/Image/pdf.png"
                                    :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                                    aspect-ratio="1"
                                    class="grey lighten-2"
                                >
                                  <template v-slot:placeholder>
                                    <v-row
                                        class="fill-height ma-0"
                                        align="center"
                                        justify="center"
                                    >
                                      <v-progress-circular
                                          indeterminate
                                          color="grey lighten-5"></v-progress-circular>
                                    </v-row>
                                  </template>
                                </v-img>
                                <v-img
                                    v-else-if="file_i.type == 'rar' || file_i.type ==  'zip'"
                                    src="../assets/Image/winzip.png"
                                    :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                                    aspect-ratio="1"
                                    class="grey lighten-2"
                                >
                                  <template v-slot:placeholder>
                                    <v-row
                                        class="fill-height ma-0"
                                        align="center"
                                        justify="center"
                                    >
                                      <v-progress-circular
                                          indeterminate
                                          color="grey lighten-5"></v-progress-circular>
                                    </v-row>
                                  </template>
                                </v-img>
                                <v-img
                                    v-else-if="file_i.type == 'word'"
                                    src="../assets/Image/word.jpg"
                                    :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                                    aspect-ratio="1"
                                    class="grey lighten-2"
                                >
                                  <template v-slot:placeholder>
                                    <v-row
                                        class="fill-height ma-0"
                                        align="center"
                                        justify="center"
                                    >
                                      <v-progress-circular
                                          indeterminate
                                          color="grey lighten-5"></v-progress-circular>
                                    </v-row>
                                  </template>
                                </v-img>
                                <v-img
                                    v-else-if="file_i.type == 'ppt'"
                                    src="../assets/Image/ppt.jpg"
                                    :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                                    aspect-ratio="1"
                                    class="grey lighten-2"
                                >
                                  <template v-slot:placeholder>
                                    <v-row
                                        class="fill-height ma-0"
                                        align="center"
                                        justify="center"
                                    >
                                      <v-progress-circular
                                          indeterminate
                                          color="grey lighten-5"></v-progress-circular>
                                    </v-row>
                                  </template>
                                </v-img>
                                <v-card-actions>
                                  <template v-if="file_i.type == 'image' ||  file_i.type == 'pdf'">
                                    <v-btn text
                                           @click="ShowData(file_i.src)">
                                                                                        <span style="color: indigo">
                                                                                            เรียกดู
                                                                                        </span>
                                    </v-btn>
                                  </template>
                                </v-card-actions>
                              </v-card>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card>
                    </v-col>
                  </v-row>
                </template>
              </v-list-item>
            </div>
            <div v-else>
              <div align="center">
                      <span class="font-weight-bold text-md-h5" style="color: darkred">
                        หมดเขตการรับสมัคร
                      </span>
              </div>
            </div>
          </template>
          <template v-else>
            <div v-if="projectData[0].DateE_Reg >= formatDateNow()">
              <div align="center">
                      <span class="font-weight-bold text-md-h5" style="color: #42b983">
                        ส่งรายชื่อสมัครเข้าร่วมโครงการ
                      </span>
              </div>
              <v-list-item>
                <v-row class="d-flex justify-center">
                  <v-col
                      cols="12"
                      md="4">
                    <v-autocomplete
                        v-model="staffSel"
                        label="ค้นหาบุคลากร"
                        :items="staffDataDump"
                        item-text="customDetail"
                        item-value="perid"
                        hint="กด Enter เพื่อเป็นการเพิ่มข้อมูล"
                        persistent-hint
                        clearable
                        outlined
                        @keyup="checkKeyEnter"
                    ></v-autocomplete>
                  </v-col>
                  <v-col
                      cols="12"
                      md="2">
                    <v-file-input
                        v-model="files"
                        color="deep-purple accent-4"
                        counter
                        label="แนบไฟล์ (ถ้ามี)"
                        multiple
                        placeholder="เลือกไฟล์"
                        prepend-icon="mdi-paperclip"
                        outlined
                        :show-size="1000"
                        @change="FileSelect"
                    >
                      <template v-slot:selection="{ index, text }">
                        <v-chip
                            v-if="index < 5"
                            color="deep-purple accent-4"
                            dark
                            label
                            small
                        >
                          {{ text }}
                        </v-chip>

                        <span
                            v-else-if="index === 5"
                            class="overline grey--text text--darken-3 mx-2"
                        >
                                +{{ files.length - 2 }} File(s)
                              </span>
                      </template>
                    </v-file-input>
                  </v-col>
                  <v-col
                      cols="12"
                      md="2">
                    <v-btn
                        class="mt-2"
                        outlined
                        color="primary"
                        @click="RequestRegister">
                      เพิ่ม
                    </v-btn>
                  </v-col>
                </v-row>
              </v-list-item>
            </div>
            <div v-else>
              <div align="center">
                      <span class="font-weight-bold text-md-h5" style="color: darkred">
                        หมดเขตการรับสมัคร
                      </span>
              </div>
            </div>
          </template>
          <v-list-item>
            <v-spacer></v-spacer>
            <v-text-field v-model="search" label="ค้นหา"></v-text-field>
          </v-list-item>
          <template v-if="projectData[0].IsRoundStatus == '1' && ProjectRound.length > 0">
            <div v-for="(round,idx) in ProjectRound" :key="idx">
              <div align="center" class="text-sm-h6 text-md-h5">
                ผู้เข้าร่วมทั้งหมด {{ JoinToProject.length }} /
                {{ (round.Status_Count_Reg == '1' ? 'ไม่จำกัด' : round.Count_Reg + ' คน') }}
                <v-btn text color="primary" @click="dialogJoinProject = true">(ตรวจสอบรายชื่อ)</v-btn>
                |
                จำนวนผู้สมัครเข้าร่วม (พิจารณาแล้ว) <span
                  style="font-weight: bold;color: #42b983">{{
                  RequestProject.filter(item => item.status_req != '0' && item.D_project_round_id == round.id).length
                }}</span>
                คน / (รอพิจารณา) <span
                  style="font-weight: bold;color: red">{{
                  RequestProject.filter(item => item.status_req == '0' && item.D_project_round_id == round.id).length
                }}</span>
                คน
              </div>
            </div>
          </template>
          <template v-else>
            <div align="center" class="text-sm-h6 text-md-h5">
              ผู้เข้าร่วมทั้งหมด {{ JoinToProject.length }} /
              {{ (projectData[0].Status_Count_Reg == '1' ? 'ไม่จำกัด' : projectData[0].Count_Reg + ' คน') }}
              <v-btn text color="primary" @click="dialogJoinProject = true">(ตรวจสอบรายชื่อ)</v-btn>
              |
              จำนวนผู้สมัครเข้าร่วม (พิจารณาแล้ว) <span
                style="font-weight: bold;color: #42b983">{{
                RequestProject.filter(item => item.status_req != '0' && (item.D_project_round_id == '' || item.D_project_round_id == null)).length
              }}</span>
              คน / (รอพิจารณา) <span
                style="font-weight: bold;color: red">{{
                RequestProject.filter(item => item.status_req == '0' && (item.D_project_round_id == '' || item.D_project_round_id == null)).length
              }}</span>
              คน
            </div>
          </template>
          <v-list-item class="d-flex justify-center mt-6">
            <v-data-table
                :search="search"
                :headers="RequestToProjectHeader"
                :items="RequestToProject">
              <template v-slot:no-data>
                <span style="color: brown;font-weight: bold">ไม่พบข้อมูลผู้สมัครเข้าร่วมโครงการ</span>
              </template>
              <template v-slot:item.file="{item}">
                <div align="center">
                  <v-btn text @click="ShowFile(item)" v-if="item.files.length > 0" color="primary">
                    {{ item.files.length }} ไฟล์
                  </v-btn>
                </div>
              </template>
              <template v-slot:item.status_req="{item}">
                          <span style="font-weight: bold;color: #42b983" class="darken-4" v-if="item.status_req == '1'">
                            อนุมัติ
                          </span>
                <span style="font-weight: bold;color: red" class="darken-4" v-else-if="item.status_req == '2'">
                            ไม่อนุมัติ
                          </span>
                <span style="font-weight: bold;color: blue" class="darken-4" v-else>
                            รอพิจารณา
                          </span>
              </template>
              <template v-slot:item.action="{item}">
                <template v-if="projectData[0].IsRoundStatus == '1' && ProjectRound.length > 0">
                  <v-btn color="red"
                         @click="DelData(item.idx, item)"
                         outlined
                         v-if="ProjectRound[0].DateE_Reg >= formatDateNow() && item.status_req == '0' && MeData[0].dep_group_id == item.dep_group_id"
                  >
                    ลบ
                  </v-btn>
                </template>
                <template v-else>
                  <v-btn color="red"
                         @click="DelData(item.idx, item)"
                         outlined
                         v-if="projectData[0].DateE_Reg >= formatDateNow() && item.status_req == '0' && MeData[0].dep_group_id == item.dep_group_id"
                  >
                    ลบ
                  </v-btn>
                </template>
              </template>
            </v-data-table>
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>
    <v-dialog
        v-model="dialogLoading"
        persistent
        width="300"
    >
      <v-card
          color="primary"
          dark
      >
        <v-card-text>
          Loading...
          <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="dialogDetail"
        width="800"
    >
      <v-card>
        <v-card-title
            color="primary"
            style="background-color: burlywood"

        >
                                <span style="color: blue;font-weight: bold"
                                      v-if="projectData.length > 0">โครงการ : {{ projectData[0].Project_name }}</span>
        </v-card-title>

        <v-card-text class="mt-4">
          <div align="center" v-if="GroupExamData.length > 0">
            <h3 style="color:darkred;">
              กลุ่มตัวอย่าง
            </h3>
          </div>
          <div align="center" v-else>
            <h3 style="color:darkred;">
              ไม่พบข้อมูลกลุ่มตัวอย่าง
            </h3>
          </div>
          <div v-for="(Exam_i,idxEx) in GroupExamData" :key="idxEx" align="center">
                        <span style="font-weight: bold;color: #364eff">
                          *** {{ Exam_i.PosName }} อายุงาน : {{ Exam_i.WSYear }} ปี ถึง {{ Exam_i.WEYear }} ***
                        </span>
          </div>
          <div align="center" v-if="QoutaDepDataDump.length > 0" style="margin-top: 25px">
            <h3 style="color:darkred;">
              จำนวนโควตาหน่วยงานเข้าร่วมโครงการ
            </h3>
          </div>
          <div align="center" v-else>
            <h3 style="color:darkred;">
              ไม่พบข้อมูลโควตาหน่วยงานเข้าร่วมโครงการ
            </h3>
          </div>
          <div v-for="(DepQ,idx) in QoutaDepDataDump" :key="idx" align="center">
                  <span v-if="DepQ.dep_type == '0'" style="font-weight: bold;color: #364eff">
                    *** หน่วยงาน : {{ depart.filter(dep_i => dep_i.dep_id == DepQ.dep_id)[0].dep_name }} จำนวน : {{
                      DepQ.count
                    }} คน ***
                  </span>
            <span v-else style="font-weight: bold;color: #364eff">
                                *** กลุ่มหน่วยงาน : {{
                depart.filter(dep_i => dep_i.dep_group_id == DepQ.dep_group_id)[0].dep_name
              }} จำนวน : {{ DepQ.count }} คน ***
                  </span>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="green darken-1"
              text
              @click="dialogDetail = false"
          >
            ปิด
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="dialogJoinProject"
        persistent
        max-width="800"
    >
      <v-card v-if="projectData.length > 0">
        <v-card-title
            color="primary"
            style="background-color: burlywood"
        >
          <span style="color: blue;font-weight: bold">โครงการ : {{ projectData[0].Project_name }}</span>
        </v-card-title>

        <v-card-text class="mt-4">
          <div align="center">
            <h3 style="color:darkred;">
              ผู้เข้าร่วมโครงการ
            </h3>
          </div>
          <div v-if="projectData.length > 0">
            <div align="center" v-if="JoinToProject.length == 0">
              <h3 style="color:darkred;">
                ไม่พบข้อมูลผู้เข้าร่วมโครงการ
              </h3>
            </div>
            <v-list-item>
              <v-spacer></v-spacer>
              <v-text-field
                  v-model="searchJoin"
                  label="ค้นหา"
                  v-if="JoinToProject.length > 0"
              ></v-text-field>
            </v-list-item>
            <v-data-table
                :headers="JoinHeader"
                :items="JoinToProject"
                :search="searchJoin"
                v-if="JoinToProject.length > 0"
            ></v-data-table>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="green darken-1"
              text
              @click="dialogJoinProject = false"
          >
            ปิด
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="dialogFile"
        width="800"
    >
      <v-card v-if="personObj != null">
        <v-card-title
            color="primary"
            style="background-color: burlywood"

        >
          <span style="color: blue;font-weight: bold">ไฟล์ประกอบ คุณ : {{ personObj.full_Name }} ({{
              personObj.perid
            }})</span>
        </v-card-title>
        <v-card-text class="mt-4">
          <div align="center" v-for="(item,idx) in personObj.files" :key="idx">
            <span style="font-weight: bold;color: black">ไฟล์ที่ : {{ idx + 1 }} - {{ item.File_name }}</span>
            <!--            <v-btn text class="ml-3" color="primary" @click="downloadFiles(item)">ดาวน์โหลด</v-btn>
                        <v-btn text color="primary" @click="ShowData(Openfile + item.File_path)" v-if="checkShowData(item)">เรียกดู</v-btn>-->
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="red darken-1"
              text
              @click="dialogFile = false"
          >
            ปิด
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-content>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import axios from "axios";
import ConstData from "@/const/Const";

export default {
  name: "RequestToJoinProject",
  data() {
    return {
      Openfile: ConstData.ConnectionHost + '/rest/files',
      dialogFile: false,
      personObj: null,
      alert: false,
      txtAlert: [],
      files: [],
      FilePerson: [],
      searchJoin: '',
      search: '',
      JoinToProject: [],
      JoinHeader: [
        {text: 'ชื่อ', value: 'name'},
        {text: 'สกุล', value: 'sname'},
        {text: 'สังกัด', value: 'affiliation'},
        {text: 'ประเภท', value: 'type_details'}
      ],
      RequestToProject: [],
      RequestToProjectHeader: [
        {text: 'ลำดับ', value: 'idx'},
        {text: 'รหัสบุคลากร', value: 'perid'},
        {text: 'ชื่อ - สกุล', value: 'full_Name'},
        {text: 'สังกัด', value: 'dep_name'},
        {text: 'ไฟล์', value: 'file'},
        {text: 'สถานะ', value: 'status_req'},
        {text: 'เหตุผล', value: 'remark'},
        {text: '', value: 'action'}
      ],
      staffSel: '',
      QoutaDepDataDump: [],
      dialogJoinProject: false,
      dialogDetail: false,
      NoRoundData: false,
      NoData: false,
      URLError: false,
      dialogLoading: false,
      DepQuotaData: [],
      ProjectQuotaDepCount: 0,
      GroupExamData: [],
      staffDataDump: [],
      headerAxios: {
        headers: {
          'Content-Type': 'application/json',
        }
      },
      headerAxiosPUT: {
        headers: {
          'X-REST-METHOD': 'PUT'
        }
      },
      headerAxiosDel: {
        headers: {
          'X-REST-METHOD': 'DELETE'
        }
      },
    }
  },
  computed: {
    ...mapGetters({
      MeData: 'Staff/getMeData',
      levelData: 'Level/getLevel',
      projectData: 'Project/getProject',
      projectForApprove: 'Project/getProjectForApprove',
      committee_Posi: 'Project/getComitteeType',
      provinces_Data: 'Project/getProvince',
      expense_Data: 'Project/getExpense',
      Competency_Data: 'Project/getCompetency',
      projectGroup: 'Project/getProjectGroup',
      QuotaDepart: 'Project/getQuotaDepart',
      GroupExamProject: 'Project/getGroupExamProject',
      RequestProject: 'Project/getRequestProject',
      JoinProject: 'Project/getJoinProject',
      ProjectRound: 'Project/getProjectRound',
      PersonFiles: 'Project/getPersonFiles',
      staffData: 'Staff/getStaff',
      positions: 'Staff/getPosition',
      CardData: 'Staff/getCard',
      depart: 'Depart/getDepart',
      courseData: 'Course/getCourse',
      AllDepPermission: 'Permission/getAllDepUserPermission',
      DepPermission: 'Permission/getDepUserPermission',
      AllPermission: 'Permission/getAllUserPermission',
      Permission: 'Permission/getPermissionUser',
      Permission_Ms: 'Permission/getPermissionMs',
      Permission_Dep_User: 'Permission/getPermissionDepUser',
      Permission_Dep: 'Permission/getPermissionDep',
      Approve_Ms: 'Permission/getApproveMs',
      Approve: 'Permission/getApprove',
      PermissionAdmin: 'Permission/getPermission',
    })
  },
  methods: {
    ...mapActions({
      initMeData: 'Staff/initMeData',
      saveSessions: 'Staff/saveSessions',
      initlevelData: 'Level/initLevelData',
      initDepartData: 'Depart/initDepartData',
      initCourseData: 'Course/initCourseData',
      initProjectDataByUUID: 'Project/initProjectDataByUUID',
      initProjectDataForApprove: 'Project/initProjectDataForApprove',
      initComitteeData: 'Project/initComitteeData',
      initComitteeType: 'Project/initComitteeType',
      initProvincesData: 'Project/initProvincesData',
      initExpenseData: 'Project/initExpenseData',
      initCompetencyData: 'Competency/initCompetencyData',
      initProjectCompetencyData: 'Project/initCompetencyData',
      initProjectGroupData: 'Project/initProjectGroupData',
      initQuotaDepartRegister: 'Project/initQuotaDepartRegister',
      initRequestProject: 'Project/initRequestProject',
      initRequestProjectByRoundID: 'Project/initRequestProjectByRoundID',
      initJoinProject: 'Project/initJoinProject',
      initGroupExamProject: 'Project/initGroupExamProject',
      getProjectRoundData: 'Project/getProjectRoundData',
      getProjectRoundDataById: 'Project/getProjectRoundDataById',
      initProjectRoundData: 'Project/initProjectRoundData',
      getJoinProjectByCordiAndUid: 'Project/getJoinProjectByCordiAndUid',
      getJoinProjectByUid: 'Project/getJoinProjectByUid',
      initPersonFileData: 'Project/initPersonFileData',
      initStaffData: 'Staff/initStaffData',
      initPositionsData: 'Staff/initPositionsData',
      initCardData: 'Staff/initCardData',
      initPermissionDepUserAllData: 'Permission/initPermissionDepUserAllData',
      initPermissionDepUserData: 'Permission/initPermissionDepUserData',
      initPermissionUserData: 'Permission/initPermissionUserData',
      initPermissionMsData: 'Permission/initPermissionMsData',
      getPermissionUserData: 'Permission/getPermissionUserData',
      getPermissionDep: 'Permission/getPermissionDepData',
      initPermissionDepData: 'Permission/initPermissionDepData',
      getPermissionDepUserData: 'Permission/getPermissionDepUserData',
      initApproveMsData: 'Permission/initApproveMsData',
      initApproveData: 'Permission/initApproveData',
      getPermissionData: 'Permission/getPermissionData',
      initPermissionData: 'Permission/initPermissionData',
    }),
    init() {
      this.staffDataDump = []
      this.JoinToProject = []
      this.RequestToProject = []

      if (this.staffData.length > 0) {
        this.staffData.map(item => {
          item.customDetail = item.full_Name + ' รหัส (' + item.perid + ')' + ' ' + item.dep_name + ' (' + item.dep_group_name + ')'
        })
        this.staffDataDump = this.staffData.filter(item => item.dep_group_name == this.MeData[0].dep_group_name)
        this.staffDataDump = this.staffData
      } else {
        this.initStaffData().then(res => {
          if (res) {
            if (this.staffData.length > 0) {
              this.staffData.map(item => {
                item.customDetail = item.full_Name + ' รหัส (' + item.perid + ')' + ' ' + item.dep_name + ' (' + item.dep_group_name + ')'
              })
              // this.staffDataDump = this.staffData.filter(item => item.dep_group_name == this.MeData[0].dep_group_name)
              this.staffDataDump = this.staffData
            }
          }
        })
      }

      this.initDepartData()

      this.initQuotaDepartRegister()

      this.initProjectDataByUUID({
        uuid: this.$route.params.uuid
      }).then(async res => {
        if (res) {
          if (this.projectData.length > 0) {
            await this.initPersonFileData({
              Project_code: this.projectData[0].Project_code
            }).catch(res => {
              if (res) {
                console.log('no files in project')
              }
            })
            this.projectData[0].Project_name = this.projectData[0].Project_name.replace(/&quot;/g, '"')
            if (this.projectData[0].IsRoundStatus == '1' && this.projectData[0].Project_code != this.$route.params.id) {
              this.getProjectRoundDataById({
                Project_code: this.projectData[0].Project_code,
                id: this.$route.params.id
              }).then(res => {
                if (res) {
                  if (this.ProjectRound.length > 0) {
                    this.GetPersonJoinProject()
                  } else {
                    this.NoRoundData = true
                  }
                }
              }).catch(res => {
                if (res) {
                  this.NoRoundData = true
                }
              })
            } else if (this.projectData[0].IsRoundStatus == '1' && this.projectData[0].Project_code == this.$route.params.id) {
              this.URLError = true
            } else if (this.projectData[0].IsRoundStatus == '0' && this.projectData[0].Project_code == this.$route.params.id) {
              this.getProjectRoundData({
                Project_code: this.projectData[0].Project_code
              }).then(res => {
                if (res) {
                  this.GetPersonJoinProject()
                }
              }).catch(res => {
                if (res) {
                  this.GetPersonJoinProject()
                }
              })
            } else {
              this.URLError = true
            }
          } else {
            this.NoData = true
          }
        }
      }).catch(res => {
        if (res) {
          this.NoData = true
        }
      })
    },
    checkShowData(item) {
      if (item.File_name.indexOf('.rar') >= 0) {
        return false;
      } else if (item.File_type == 'application/x-zip-compressed') {
        return false;
      } else {
        switch (item.File_type) {
          case 'image/jpg':
          case 'image/jpeg':
          case 'image/gif':
          case 'image/bmp':
          case 'image/png':
            return true;
          case 'application/pdf':
            return true;
          default:
            return false;
        }
      }
    },
    downloadFiles(item) {
      var link = document.createElement("a");
      // If you don't know the name or want to use
      // the webserver default set name = ''
      link.setAttribute('download', item.File_name);
      link.href = this.Openfile + item.File_path;
      document.body.appendChild(link);
      link.click();
      link.remove();
    },
    ShowData(dataUrl) {
      window.open(
          dataUrl,
          '_blank' // <- This is what makes it open in a new window.
      );
    },
    ShowFile(item) {
      this.personObj = null
      this.personObj = item
      this.dialogFile = true
    },
    FileSelect: function () {
      // var count = 0
      this.alert = false
      this.txtAlert = []
      this.FilePerson = []
      this.alert = false
      if (this.files.length > 0) {
        this.files.map((item) => {
          var Checkfile = false;
          if (item.name.indexOf('.rar') >= 0) {
            Checkfile = true;
          } else if (item.type == 'application/x-zip-compressed') {
            Checkfile = true;
          } else {
            switch (item.type) {
              case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
              case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
              case 'image/jpeg':
              case 'image/gif':
              case 'image/bmp':
              case 'image/png':
                Checkfile = true;
                break
              case 'application/pdf':
                Checkfile = true;
                break
              default:
                Checkfile = false;
                break
            }
          }

          if (Checkfile) {
            if (item.size > 25000000) {
              this.txtAlert.push({
                id: this.txtAlert.length + 1,
                Detail: 'ไฟล์ ' + item.name + ' ขนาดเกิน 25 mb*'
              })
            }
          } else {
            this.txtAlert.push({
              id: this.txtAlert.length + 1,
              Detail: 'ไม่สนับสนุนนามสกุลไฟล์ ' + item.type + ' ( ' + item.name + ' ) '
            })
          }
        })
        // setTimeout(() => {
        //   this.alert = false
        // }, 3000)
      }

      if (this.txtAlert.length == 0) {
        this.dialogLoading = true
        var idx = 0
        if (this.files.length > 0) {
          this.files.map(async (item) => {
            const fd = new FormData()
            fd.append('file', item, item.name)
            const headerAxios = {
              headers: {
                'Content-Type': 'multipart/form-data',
                'WithCredentials': true,
                "Access-Control-Allow-Origin": "*"
                // "Accept": 'multipart/form-data'
              }
            }

            await axios.post(ConstData.ConnectionHost + '/rest/v1/hrcardnew/uploadfile', fd, headerAxios).then(res => {
              if (res.data.status) {
                if (item.name.indexOf('.rar') >= 0) {
                  this.FilePerson.push({
                    name: item.name,
                    src: URL.createObjectURL(item),
                    path: res.data.path,
                    type: 'rar',
                    type_Img: item.type
                  })
                } else if (item.type == 'application/x-zip-compressed') {
                  this.FilePerson.push({
                    name: item.name,
                    src: URL.createObjectURL(item),
                    path: res.data.path,
                    type: 'zip',
                    type_Img: item.type
                  })
                } else if (item.type == 'application/vnd.openxmlformats-officedocument.presentationml.presentation') {
                  this.FilePerson.push({
                    name: item.name,
                    src: URL.createObjectURL(item),
                    path: res.data.path,
                    type: 'ppt',
                    type_Img: item.type
                  })
                } else if (item.type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
                  this.FilePerson.push({
                    name: item.name,
                    src: URL.createObjectURL(item),
                    path: res.data.path,
                    type: 'word',
                    type_Img: item.type
                  })
                } else {
                  switch (item.type) {
                    case 'image/jpg':
                    case 'image/jpeg':
                    case 'image/gif':
                    case 'image/bmp':
                    case 'image/png':
                      this.FilePerson.push({
                        name: item.name,
                        src: URL.createObjectURL(item),
                        path: res.data.path,
                        type: 'image',
                        type_Img: item.type
                      })
                      break
                    case 'application/pdf':
                      this.FilePerson.push({
                        name: item.name,
                        src: URL.createObjectURL(item),
                        path: res.data.path,
                        type: 'pdf',
                        type_Img: item.type
                      })
                      break
                    default:
                      break
                  }
                }
              }
              idx++
              if (idx == this.files.length) {
                this.dialogLoading = false
              }
            })
          })
        } else {
          this.dialogLoading = false
        }
      } else {
        this.$swal.fire({
          icon: 'error',
          title: 'ไม่สามารถอัพโหลดไฟล์ได้ เนื่องจากพบไฟล์ ไม่เข้าเงื่อนไขการอัพโหลด โปรดตรวจสอบข้อความข้อผิดพลาดพร้อมแก้ไขและลองอีกครั้ง!!'
        })
        this.alert = true
      }

    },
    DelData(idx, item) {
      this.$swal.fire({
        title: 'ยืนยันการทำรายการ',
        text: "คุณต้องการลบรายชื่อผู้สมัครเข้าร่วมโครงการ คุณ : " + item.full_Name + ' ใช่หรือไม่ ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.value) {
          axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/request_project/id/' + item.id).then(res => {
            if (res.data) {
              if (res.data.status_req != '0') {
                this.$swal.fire({
                  icon: 'error',
                  title: 'ไม่สามารถลบข้อมูลผู้สมัครได้ เนื่องจากผู้สมัครที่เลือกได้ถูกพิจารณาสถานะการเข้าร่วมแล้ว!!'
                })
              } else {
                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/request_project/id/' + item.id, {
                  active: '0',
                  update_by: this.MeData[0].perid
                }, this.headerAxios).then(res => {
                  if (res.data.status) {
                    if (this.ProjectRound.length > 0) {
                      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Person_files/Project_code/' + this.projectData[0].Project_code + '/D_project_round_id/' + this.ProjectRound[0].id + '/perid/' + item.perid, {
                        active: '0',
                        update_by: this.MeData[0].perid
                      }, this.headerAxios)
                    } else {
                      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Person_files/Project_code/' + this.projectData[0].Project_code + '/perid/' + item.perid, {
                        active: '0',
                        update_by: this.MeData[0].perid
                      }, this.headerAxios)
                    }
                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/request_project_history/', {
                      request_project_id: item.id,
                      create_by: this.MeData[0].perid
                    }, this.headerAxiosPUT)
                    this.staffSel = ''
                    this.$swal.fire({
                      icon: 'success',
                      title: 'ลบข้อมูลผู้สมัคร คุณ : ' + item.full_Name + ' สำเร็จ'
                    })
                    this.init()
                  } else {
                    this.staffSel = ''
                    this.$swal.fire({
                      icon: 'error',
                      title: 'พบข้อผิดพลาด ไม่สามารถลบข้อมูลบุคลากรได้'
                    })
                  }
                })
              }
            } else {
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/request_project/id/' + item.id, {
                active: '0',
                update_by: this.MeData[0].perid
              }, this.headerAxios).then(res => {
                if (res.data.status) {
                  if (this.ProjectRound.length > 0) {
                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Person_files/Project_code/' + this.projectData[0].Project_code + '/D_project_round_id/' + this.ProjectRound[0].id + '/perid/' + item.perid, {
                      active: '0',
                      update_by: this.MeData[0].perid
                    }, this.headerAxios)
                  } else {
                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Person_files/Project_code/' + this.projectData[0].Project_code + '/perid/' + item.perid, {
                      active: '0',
                      update_by: this.MeData[0].perid
                    }, this.headerAxios)
                  }
                  axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/request_project_history/', {
                    request_project_id: item.id,
                    create_by: this.MeData[0].perid
                  }, this.headerAxiosPUT)
                  this.staffSel = ''
                  this.$swal.fire({
                    icon: 'success',
                    title: 'ลบข้อมูลผู้สมัคร คุณ : ' + item.full_Name + ' สำเร็จ'
                  })
                  this.init()
                } else {
                  this.staffSel = ''
                  this.$swal.fire({
                    icon: 'error',
                    title: 'พบข้อผิดพลาด ไม่สามารถลบข้อมูลบุคลากรได้'
                  })
                }
              })
            }
          })
        }
      })
    },
    GetPersonJoinProject() {
      if (this.projectData.length > 0) {
        this.projectData.map((proj_I) => {
          var url = ''
          if (proj_I.IsRoundStatus == '0') {
            url = ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/join_project_view/Project_code/' + proj_I.Project_code + '/active/1/?limit=9999'
          } else {
            if (this.ProjectRound.length > 0) {
              url = ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/join_project_view/Project_code/' + proj_I.Project_code + '/active/1/D_project_round_id/' + this.ProjectRound[0].id + '/?limit=9999'
            }
          }
          axios.get(url).then(res => {
            if (res.data) {
              if (res.data.length > 0) {
                var ProjectReq = []
                if (this.ProjectRound.length > 0) {
                  ProjectReq = res.data.filter(reqI => reqI.D_project_round_id == this.ProjectRound[0].id)
                }
                if (ProjectReq.length > 0) {
                  this.JoinToProject = res.data
                } else {
                  this.JoinToProject = res.data.filter(item => (item.D_project_round_id == '' || item.D_project_round_id == null))
                }
              } else {
                if (this.ProjectRound.length > 0) {
                  if (res.data.D_project_round_id == this.ProjectRound[0].id) {
                    this.JoinToProject = new Array(res.data)
                  } else {
                    this.JoinToProject = new Array(res.data)
                  }
                } else {
                  if (res.data.D_project_round_id == '' || res.data.D_project_round_id == null) {
                    this.JoinToProject = new Array(res.data)
                  }
                }
              }
            } else {
              console.log('data not found')
            }
          })

          if (this.ProjectRound.length > 0) {
            this.initRequestProjectByRoundID({
              Project_code: proj_I.Project_code,
              id: this.ProjectRound[0].id
            }).then(res => {
              if (res) {
                if (this.RequestProject.length > 0) {
                  this.RequestProject.map((reqI, idx) => this.RequestToProject.push({
                    ...reqI,
                    idx: idx + 1,
                    files: (this.PersonFiles.length > 0 ? this.PersonFiles.filter(item => item.Project_code == proj_I.Project_code && item.D_project_round_id == this.ProjectRound[0].id && item.perid == reqI.perid) : [])
                  }))
                }
              }
            }).catch(res => {
              console.log(res)
            })
          } else {
            this.initRequestProject({
              Project_code: proj_I.Project_code
            }).then(res => {
              if (res) {
                if (this.RequestProject.length > 0) {
                  this.RequestProject.map((reqI, idx) => {
                    if (reqI.D_project_round_id == '' || reqI.D_project_round_id == null) {
                      this.RequestToProject.push({
                        ...reqI,
                        idx: idx + 1,
                        files: (this.PersonFiles.length > 0 ? this.PersonFiles.filter(item => item.Project_code == proj_I.Project_code && (item.D_project_round_id == '' || item.D_project_round_id == null) && item.perid == reqI.perid) : [])
                      })
                    }
                  })
                }
              }
            }).catch(res => {
              console.log(res)
            })
          }
        })
      }
    },
    checkKeyEnter(event) {
      if (event.key == "Enter") {
        if (this.staffSel != '') {
          this.RequestRegister()
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'โปรดระบุรหัสบุคลากร'
          })
        }
      }
    },
    RequestRegister() {
      var CheckCordi = false
      var CheckCordi2 = '0'
      this.GroupExamData = []
      if (this.staffSel != '') {
        this.$swal.fire({
          title: 'ยืนยันการทำรายการ',
          text: "ต้องการสมัครเข้าร่วมโครงการ ใช่หรือไม่ ?",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'ตกลง',
          cancelButtonText: 'ยกเลิก'
        }).then((result) => {
          if (result.value) {
            if (this.projectData[0].IsRoundStatus == '0') {
              this.getJoinProjectByUid({
                Project_code: this.projectData[0].Project_code,
                perid: this.staffSel
              }).then(res => {
                if (res) {
                  if (this.JoinProject.length == 0) {
                    if ((this.projectData[0].DateS_Reg != null && this.projectData[0].DateS_Reg != '0000-00-00') && (this.projectData[0].DateE_Reg != null && this.projectData[0].DateE_Reg != '0000-00-00')) {
                      if ((this.GetDateNow() >= this.projectData[0].DateS_Reg) && (this.GetDateNow() <= this.projectData[0].DateE_Reg)) {
                        CheckCordi = true
                      } else {
                        CheckCordi = false
                        CheckCordi2 = '1'
                      }
                    } else if ((this.projectData[0].DateS_Reg != null && this.projectData[0].DateS_Reg != '0000-00-00') && (this.projectData[0].DateE_Reg == null || this.projectData[0].DateE_Reg == '0000-00-00')) {
                      if (this.GetDateNow() >= this.projectData[0].DateS_Reg) {
                        CheckCordi = true
                      } else {
                        CheckCordi = false
                        CheckCordi2 = '2'
                      }
                    } else if ((this.projectData[0].DateS_Reg == null || this.projectData[0].DateS_Reg == '0000-00-00') && (this.projectData[0].DateE_Reg != null && this.projectData[0].DateE_Reg != '0000-00-00')) {
                      if (this.GetDateNow() <= this.projectData[0].DateE_Reg) {
                        CheckCordi = true
                      } else {
                        CheckCordi = false
                        CheckCordi2 = '3'
                      }
                    } else {
                      CheckCordi = false
                      CheckCordi2 = '4'
                    }

                    if (CheckCordi) {
                      this.QoutaDepDataDump = []
                      this.DepQuotaData = []
                      this.ProjectQuotaDepCount = 0

                      this.QoutaDepDataDump = this.UniqueArraybyId(this.QuotaDepart, 'id')
                      this.QoutaDepDataDump = this.QoutaDepDataDump.filter(item => item.Project_code == this.projectData[0].Project_code)
                      if (this.QoutaDepDataDump.length > 0) {
                        this.QoutaDepDataDump.map(DepQ => {
                          this.ProjectQuotaDepCount += parseInt(DepQ.count)
                        })
                        this.DepQuotaData = this.QoutaDepDataDump
                      }

                      this.initGroupExamProject({
                        Project_code: this.projectData[0].Project_code
                      }).then(res => {
                        if (res) {
                          if (this.projectData[0].IsRoundStatus == '0') {
                            this.GroupExamData = this.GroupExamProject
                          } else {
                            if (this.ProjectRound.length > 0) {
                              var GroupExDump = this.GroupExamProject.filter(GroupI => GroupI.D_project_round_id == this.ProjectRound[0].id)
                              if (GroupExDump.length > 0) {
                                this.GroupExamData = GroupExDump
                              }
                            }
                          }

                          this.ChooseEmpolyee_s()
                        }
                      }).catch(reason => {
                        if (reason) {
                          this.ChooseEmpolyee_s()
                        }
                      })
                    } else {
                      switch (CheckCordi2) {
                        case "1":
                          this.staffSel = ''
                          this.$swal.fire({
                            icon: 'error',
                            title: 'ไม่สามารถสมัครเข้าร่วมโครงการได้ เนื่องจากไม่ได้อยู่ในช่วงรับที่เปิดรับสมัคร'
                          })
                          break
                        case "2":
                          this.staffSel = ''
                          this.$swal.fire({
                            icon: 'error',
                            title: 'ไม่สามารถสมัครเข้าร่วมโครงการได้ เนื่องจากยังไม่ถึงวันที่เปิดรับสมัคร'
                          })
                          break
                        case "3":
                          this.staffSel = ''
                          this.$swal.fire({
                            icon: 'error',
                            title: 'ไม่สามารถสมัครเข้าร่วมโครงการได้ หมดระยะเวลาการรับสมัคร'
                          })
                          break
                        case "4":
                          this.staffSel = ''
                          this.$swal.fire({
                            icon: 'error',
                            title: 'ไม่สามารถสมัครเข้าร่วมโครงการได้ เนื่องจากโครงการไม่ระบุวันที่ เปิด - ปิด การรับสมัคร'
                          })
                          break
                        default:
                          break
                      }
                    }
                  } else {
                    this.staffSel = ''
                    this.$swal.fire({
                      icon: 'error',
                      title: 'ไม่สามารถสมัครเข้าร่วมโครงการได้ เนื่องจากคุณได้เป็นผู้เข้าร่วมโครงการอยู่แล้ว !!'
                    })
                  }
                }
              }).catch(reason => {
                if (reason) {
                  if ((this.projectData[0].DateS_Reg != null && this.projectData[0].DateS_Reg != '0000-00-00') && (this.projectData[0].DateE_Reg != null && this.projectData[0].DateE_Reg != '0000-00-00')) {
                    if ((this.GetDateNow() >= this.projectData[0].DateS_Reg) && (this.GetDateNow() <= this.projectData[0].DateE_Reg)) {
                      CheckCordi = true
                    } else {
                      CheckCordi = false
                      CheckCordi2 = '1'
                    }
                  } else if ((this.projectData[0].DateS_Reg != null && this.projectData[0].DateS_Reg != '0000-00-00') && (this.projectData[0].DateE_Reg == null || this.projectData[0].DateE_Reg == '0000-00-00')) {
                    if (this.GetDateNow() >= this.projectData[0].DateS_Reg) {
                      CheckCordi = true
                    } else {
                      CheckCordi = false
                      CheckCordi2 = '2'
                    }
                  } else if ((this.projectData[0].DateS_Reg == null || this.projectData[0].DateS_Reg == '0000-00-00') && (this.projectData[0].DateE_Reg != null && this.projectData[0].DateE_Reg != '0000-00-00')) {
                    if (this.GetDateNow() <= this.projectData[0].DateE_Reg) {
                      CheckCordi = true
                    } else {
                      CheckCordi = false
                      CheckCordi2 = '3'
                    }
                  } else {
                    CheckCordi = false
                    CheckCordi2 = '4'
                  }

                  if (CheckCordi) {
                    this.QoutaDepDataDump = []
                    this.DepQuotaData = []
                    this.ProjectQuotaDepCount = 0

                    this.QoutaDepDataDump = this.UniqueArraybyId(this.QuotaDepart, 'id')
                    this.QoutaDepDataDump = this.QoutaDepDataDump.filter(item => item.Project_code == this.projectData[0].Project_code)
                    if (this.QoutaDepDataDump.length > 0) {
                      this.QoutaDepDataDump.map(DepQ => {
                        this.ProjectQuotaDepCount += parseInt(DepQ.count)
                      })
                      this.DepQuotaData = this.QoutaDepDataDump
                    }

                    this.initGroupExamProject({
                      Project_code: this.projectData[0].Project_code
                    }).then(res => {
                      if (res) {
                        if (this.projectData[0].IsRoundStatus == '0') {
                          this.GroupExamData = this.GroupExamProject
                        } else {
                          if (this.ProjectRound.length > 0) {
                            var GroupExDump = this.GroupExamProject.filter(GroupI => GroupI.D_project_round_id == this.ProjectRound[0].id)
                            if (GroupExDump.length > 0) {
                              this.GroupExamData = GroupExDump
                            }
                          }
                        }

                        this.ChooseEmpolyee_s()
                      }
                    }).catch(reason => {
                      if (reason) {
                        this.ChooseEmpolyee_s()
                      }
                    })
                  } else {
                    switch (CheckCordi2) {
                      case "1":
                        this.staffSel = ''
                        this.$swal.fire({
                          icon: 'error',
                          title: 'ไม่สามารถสมัครเข้าร่วมโครงการได้ เนื่องจากไม่ได้อยู่ในช่วงรับที่เปิดรับสมัคร'
                        })
                        break
                      case "2":
                        this.staffSel = ''
                        this.$swal.fire({
                          icon: 'error',
                          title: 'ไม่สามารถสมัครเข้าร่วมโครงการได้ เนื่องจากยังไม่ถึงวันที่เปิดรับสมัคร'
                        })
                        break
                      case "3":
                        this.staffSel = ''
                        this.$swal.fire({
                          icon: 'error',
                          title: 'ไม่สามารถสมัครเข้าร่วมโครงการได้ หมดระยะเวลาการรับสมัคร'
                        })
                        break
                      case "4":
                        this.staffSel = ''
                        this.$swal.fire({
                          icon: 'error',
                          title: 'ไม่สามารถสมัครเข้าร่วมโครงการได้ เนื่องจากโครงการไม่ระบุวันที่ เปิด - ปิด การรับสมัคร'
                        })
                        break
                      default:
                        break
                    }
                  }
                }
              })
            } else {
              if (this.ProjectRound.length > 0) {
                this.getJoinProjectByCordiAndUid({
                  Project_code: this.projectData[0].Project_code,
                  id: this.ProjectRound[0].id,
                  perid: this.staffSel,
                }).then(res => {
                  if (res) {
                    if (this.JoinProject.length == 0) {
                      if ((this.ProjectRound[0].DateS_Reg != null && this.ProjectRound[0].DateS_Reg != '0000-00-00') && (this.ProjectRound[0].DateE_Reg != null && this.ProjectRound[0].DateE_Reg != '0000-00-00')) {
                        if ((this.GetDateNow() >= this.ProjectRound[0].DateS_Reg) && (this.GetDateNow() <= this.ProjectRound[0].DateE_Reg)) {
                          CheckCordi = true
                        } else {
                          CheckCordi = false
                          CheckCordi2 = '1'
                        }
                      } else if ((this.ProjectRound[0].DateS_Reg != null && this.ProjectRound[0].DateS_Reg != '0000-00-00') && (this.ProjectRound[0].DateE_Reg == null || this.ProjectRound[0].DateE_Reg == '0000-00-00')) {
                        if (this.GetDateNow() >= this.ProjectRound[0].DateS_Reg) {
                          CheckCordi = true
                        } else {
                          CheckCordi = false
                          CheckCordi2 = '2'
                        }
                      } else if ((this.ProjectRound[0].DateS_Reg == null || this.ProjectRound[0].DateS_Reg == '0000-00-00') && (this.ProjectRound[0].DateE_Reg != null && this.ProjectRound[0].DateE_Reg != '0000-00-00')) {
                        if (this.GetDateNow() <= this.ProjectRound[0].DateE_Reg) {
                          CheckCordi = true
                        } else {
                          CheckCordi = false
                          CheckCordi2 = '3'
                        }
                      } else {
                        CheckCordi = false
                        CheckCordi2 = '4'
                      }

                      if (CheckCordi) {
                        this.QoutaDepDataDump = []
                        this.DepQuotaData = []
                        this.ProjectQuotaDepCount = 0

                        this.QoutaDepDataDump = this.UniqueArraybyId(this.QuotaDepart, 'id')
                        this.QoutaDepDataDump = this.QoutaDepDataDump.filter(item => item.Project_code == this.projectData[0].Project_code)
                        if (this.QoutaDepDataDump.length > 0) {
                          this.QoutaDepDataDump.map(DepQ => {
                            this.ProjectQuotaDepCount += parseInt(DepQ.count)
                          })
                          this.DepQuotaData = this.QoutaDepDataDump
                        }

                        this.initGroupExamProject({
                          Project_code: this.projectData[0].Project_code
                        }).then(res => {
                          if (res) {
                            if (this.projectData[0].IsRoundStatus == '0') {
                              this.GroupExamData = this.GroupExamProject
                            } else {
                              if (this.ProjectRound.length > 0) {
                                var GroupExDump = this.GroupExamProject.filter(GroupI => GroupI.D_project_round_id == this.ProjectRound[0].id)
                                if (GroupExDump.length > 0) {
                                  this.GroupExamData = GroupExDump
                                }
                              }
                            }
                            this.ChooseEmpolyee_s()
                          }
                        }).catch(reason => {
                          if (reason) {
                            this.ChooseEmpolyee_s()
                          }
                        })
                      } else {
                        switch (CheckCordi2) {
                          case "1":
                            this.staffSel = ''
                            this.$swal.fire({
                              icon: 'error',
                              title: 'ไม่สามารถสมัครเข้าร่วมโครงการได้ เนื่องจากไม่ได้อยู่ในช่วงรับที่เปิดรับสมัคร'
                            })
                            break
                          case "2":
                            this.staffSel = ''
                            this.$swal.fire({
                              icon: 'error',
                              title: 'ไม่สามารถสมัครเข้าร่วมโครงการได้ เนื่องจากยังไม่ถึงวันที่เปิดรับสมัคร'
                            })
                            break
                          case "3":
                            this.staffSel = ''
                            this.$swal.fire({
                              icon: 'error',
                              title: 'ไม่สามารถสมัครเข้าร่วมโครงการได้ หมดระยะเวลาการรับสมัคร'
                            })
                            break
                          case "4":
                            this.staffSel = ''
                            this.$swal.fire({
                              icon: 'error',
                              title: 'ไม่สามารถสมัครเข้าร่วมโครงการได้ เนื่องจากโครงการไม่ระบุวันที่ เปิด - ปิด การรับสมัคร'
                            })
                            break
                          default:
                            break
                        }
                      }
                    } else {
                      this.staffSel = ''
                      this.$swal.fire({
                        icon: 'error',
                        title: 'ไม่สามารถสมัครเข้าร่วมโครงการได้ เนื่องจากคุณได้เป็นผู้เข้าร่วมโครงการอยู่แล้ว !!'
                      })
                    }
                  }
                }).catch(reason => {
                  if (reason) {
                    if ((this.ProjectRound[0].DateS_Reg != null && this.ProjectRound[0].DateS_Reg != '0000-00-00') && (this.ProjectRound[0].DateE_Reg != null && this.ProjectRound[0].DateE_Reg != '0000-00-00')) {
                      if ((this.GetDateNow() >= this.ProjectRound[0].DateS_Reg) && (this.GetDateNow() <= this.ProjectRound[0].DateE_Reg)) {
                        CheckCordi = true
                      } else {
                        CheckCordi = false
                        CheckCordi2 = '1'
                      }
                    } else if ((this.ProjectRound[0].DateS_Reg != null && this.ProjectRound[0].DateS_Reg != '0000-00-00') && (this.ProjectRound[0].DateE_Reg == null || this.ProjectRound[0].DateE_Reg == '0000-00-00')) {
                      if (this.GetDateNow() >= this.ProjectRound[0].DateS_Reg) {
                        CheckCordi = true
                      } else {
                        CheckCordi = false
                        CheckCordi2 = '2'
                      }
                    } else if ((this.ProjectRound[0].DateS_Reg == null || this.ProjectRound[0].DateS_Reg == '0000-00-00') && (this.ProjectRound[0].DateE_Reg != null && this.ProjectRound[0].DateE_Reg != '0000-00-00')) {
                      if (this.GetDateNow() <= this.ProjectRound[0].DateE_Reg) {
                        CheckCordi = true
                      } else {
                        CheckCordi = false
                        CheckCordi2 = '3'
                      }
                    } else {
                      CheckCordi = false
                      CheckCordi2 = '4'
                    }

                    if (CheckCordi) {
                      this.QoutaDepDataDump = []
                      this.DepQuotaData = []
                      this.ProjectQuotaDepCount = 0

                      this.QoutaDepDataDump = this.UniqueArraybyId(this.QuotaDepart, 'id')
                      this.QoutaDepDataDump = this.QoutaDepDataDump.filter(item => item.Project_code == this.projectData[0].Project_code)
                      if (this.QoutaDepDataDump.length > 0) {
                        this.QoutaDepDataDump.map(DepQ => {
                          this.ProjectQuotaDepCount += parseInt(DepQ.count)
                        })
                        this.DepQuotaData = this.QoutaDepDataDump
                      }

                      this.initGroupExamProject({
                        Project_code: this.projectData[0].Project_code
                      }).then(res => {
                        if (res) {
                          if (this.projectData[0].IsRoundStatus == '0') {
                            this.GroupExamData = this.GroupExamProject
                          } else {
                            if (this.ProjectRound.length > 0) {
                              var GroupExDump = this.GroupExamProject.filter(GroupI => GroupI.D_project_round_id == this.ProjectRound[0].id)
                              if (GroupExDump.length > 0) {
                                this.GroupExamData = GroupExDump
                              }
                            }
                          }
                          this.ChooseEmpolyee_s()
                        }
                      }).catch(reason => {
                        if (reason) {
                          this.ChooseEmpolyee_s()
                        }
                      })
                    } else {
                      switch (CheckCordi2) {
                        case "1":
                          this.staffSel = ''
                          this.$swal.fire({
                            icon: 'error',
                            title: 'ไม่สามารถสมัครเข้าร่วมโครงการได้ เนื่องจากไม่ได้อยู่ในช่วงรับที่เปิดรับสมัคร'
                          })
                          break
                        case "2":
                          this.staffSel = ''
                          this.$swal.fire({
                            icon: 'error',
                            title: 'ไม่สามารถสมัครเข้าร่วมโครงการได้ เนื่องจากยังไม่ถึงวันที่เปิดรับสมัคร'
                          })
                          break
                        case "3":
                          this.staffSel = ''
                          this.$swal.fire({
                            icon: 'error',
                            title: 'ไม่สามารถสมัครเข้าร่วมโครงการได้ หมดระยะเวลาการรับสมัคร'
                          })
                          break
                        case "4":
                          this.staffSel = ''
                          this.$swal.fire({
                            icon: 'error',
                            title: 'ไม่สามารถสมัครเข้าร่วมโครงการได้ เนื่องจากโครงการไม่ระบุวันที่ เปิด - ปิด การรับสมัคร'
                          })
                          break
                        default:
                          break
                      }
                    }
                  }
                })
              } else {
                this.staffSel = ''
                this.$swal.fire({
                  icon: 'error',
                  title: 'ไม่สามารถสมัครเข้าร่วมโครงการได้ เนื่องจากไม่พบข้อมูลการกำหนดรุ่นที่จัดของโครงการ'
                })
              }
            }
          }
        })
      } else {
        this.staffSel = ''
        this.$swal.fire({
          icon: 'error',
          title: 'โปรดระบุรหัสบุคลากร'
        })
      }
    },
    UploadFilesToDb(Project_code, Round_id, perid) {
      var countFilePerson = 0
      this.FilePerson.map((item) => {
        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Person_files', {
          Project_code: Project_code,
          D_project_round_id: Round_id,
          perid: perid,
          File_name: item.name,
          File_path: item.path,
          File_type: item.type_Img,
          Create_By: this.MeData[0].perid,
          Create_Time: 'now()',
        }, {
          headers: {
            'Content-Type': 'application/json',
            'X-REST-METHOD': 'PUT'
          }
        }).then(res => {
          if (res.data.status) {
            countFilePerson++
            if (countFilePerson == this.FilePerson.length) {
              this.FilePerson = []
              this.files = []
              this.txtAlert = []
              this.alert = false
            }
          }
        })
      })
    },
    ChooseEmpolyee_s() {
      var CheckDupe = false
      var CheckDepMatch = false
      var countPerson = 0
      var CheckGroupExample = []
      this.staffData.map((staff_I) => {
        if (staff_I.perid == this.staffSel) {
          if (this.GroupExamData.length > 0) {
            CheckGroupExample = this.GroupExamData.filter(item => item.PosCode == staff_I.pos_id && this.getAge(new Date(staff_I.date_in), new Date())[0] >= item.WSYear && this.getAge(new Date(staff_I.date_in), new Date())[0] <= item.WEYear)
            if (CheckGroupExample.length > 0) {
              if (this.DepQuotaData.length > 0) {
                this.DepQuotaData.map((dep_quota, idx) => {
                  if (dep_quota.dep_type == '0' && !CheckDepMatch) {
                    if (staff_I.dep_id == dep_quota.dep_id) {
                      CheckDepMatch = true
                      if (this.RequestProject.length > 0) {
                        if (this.RequestProject.filter(item => item.dep_id == staff_I.dep_id && item.status_req != '2').length < parseInt(dep_quota.count)) {
                          if (this.projectData[0].IsRoundStatus == '0') {
                            if (this.RequestProject.filter(item => item.perid == staff_I.perid && item.Project_code == this.projectData[0].Project_code && (item.D_project_round_id == '' || item.D_project_round_id == null)).length > 0) {
                              CheckDupe = true
                            }
                          } else {
                            if (this.ProjectRound.length > 0) {
                              if (this.RequestProject.filter(item => item.perid == staff_I.perid && item.Project_code == this.projectData[0].Project_code && item.D_project_round_id == this.ProjectRound[0].id).length > 0) {
                                CheckDupe = true
                              }
                            }
                          }

                          if (!CheckDupe) {
                            this.clearRequestRegister(this.projectData[0].Project_code, (this.ProjectRound.length > 0 ? this.ProjectRound[0].id : ''), this.staffSel).then(resClear => {
                              if (resClear) {
                                this.insertDataToDB({
                                  Project_code: this.projectData[0].Project_code,
                                  D_project_round_id: (this.ProjectRound.length > 0 ? this.ProjectRound[0].id : ''),
                                  perid: staff_I.perid,
                                  status_req: '0',
                                  Create_By: this.MeData[0].perid,
                                  Create_Time: 'now()',
                                }).then(res => {
                                  if (res.status) {
                                    this.$swal.fire({
                                      timer: 1500,
                                      showConfirmButton: false,
                                      icon: 'success',
                                      title: 'บันทึกข้อมูลผู้เข้าร่วมโครงการ ' + staff_I.full_Name + ' สำเร็จ!!'
                                    })
                                    if (this.FilePerson.length > 0) {
                                      this.UploadFilesToDb(this.projectData[0].Project_code, (this.ProjectRound.length > 0 ? this.ProjectRound[0].id : ''), staff_I.perid)
                                    }
                                    this.staffSel = ''
                                    this.projectDataToTableDump2 = ''
                                    this.init()
                                  } else {
                                    this.staffSel = ''
                                    this.$swal.fire({
                                      icon: 'error',
                                      title: 'พบข้อผืดพลาด ไม่สามารถบันทึกข้อมูลได้'
                                    })
                                  }
                                })
                              }
                            })
                          } else {
                            this.staffSel = ''
                            this.$swal.fire({
                              icon: 'error',
                              title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                            })
                          }
                        } else {
                          this.staffSel = ''
                          this.$swal.fire({
                            icon: 'error',
                            title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากจำนวนผู้เข้าร่วมของหน่วยงาน ' + staff_I.dep_name + ' เกินกำหนดที่ตั้งไว้'
                          })
                        }
                      } else {
                        if (this.projectData[0].IsRoundStatus == '0') {
                          if (this.RequestProject.filter(item => item.perid == staff_I.perid && item.Project_code == this.projectData[0].Project_code && (item.D_project_round_id == '' || item.D_project_round_id == null)).length > 0) {
                            CheckDupe = true
                          }
                        } else {
                          if (this.ProjectRound.length > 0) {
                            if (this.RequestProject.filter(item => item.perid == staff_I.perid && item.Project_code == this.projectData[0].Project_code && item.D_project_round_id == this.ProjectRound[0].id).length > 0) {
                              CheckDupe = true
                            }
                          }
                        }
                        if (!CheckDupe) {
                          this.clearRequestRegister(this.projectData[0].Project_code, (this.ProjectRound.length > 0 ? this.ProjectRound[0].id : ''), this.staffSel).then(resClear => {
                            if (resClear) {
                              this.insertDataToDB({
                                Project_code: this.projectData[0].Project_code,
                                D_project_round_id: (this.ProjectRound.length > 0 ? this.ProjectRound[0].id : ''),
                                perid: staff_I.perid,
                                status_req: '0',
                                Create_By: this.MeData[0].perid,
                                Create_Time: 'now()',
                              }).then(res => {
                                if (res.status) {
                                  this.$swal.fire({
                                    timer: 1500,
                                    showConfirmButton: false,
                                    icon: 'success',
                                    title: 'บันทึกข้อมูลผู้เข้าร่วมโครงการ ' + staff_I.full_Name + ' สำเร็จ!!'
                                  })
                                  if (this.FilePerson.length > 0) {
                                    this.UploadFilesToDb(this.projectData[0].Project_code, (this.ProjectRound.length > 0 ? this.ProjectRound[0].id : ''), staff_I.perid)
                                  }
                                  this.projectDataToTableDump2 = ''
                                  this.staffSel = ''
                                  this.init()
                                } else {
                                  this.staffSel = ''
                                  this.$swal.fire({
                                    icon: 'error',
                                    title: 'พบข้อผืดพลาด ไม่สามารถบันทึกข้อมูลได้'
                                  })
                                }
                              })
                            }
                          })
                        } else {
                          this.staffSel = ''
                          this.$swal.fire({
                            icon: 'error',
                            title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                          })
                        }
                      }
                    } else {
                      if (!CheckDepMatch && idx == this.DepQuotaData.length - 1) {
                        if (this.projectData[0].Status_Count_Reg == '1') {
                          if (this.projectData[0].IsRoundStatus == '0') {
                            if (this.RequestProject.filter(item => item.perid == staff_I.perid && item.Project_code == this.projectData[0].Project_code && (item.D_project_round_id == '' || item.D_project_round_id == null)).length > 0) {
                              CheckDupe = true
                            }
                          } else {
                            if (this.ProjectRound.length > 0) {
                              if (this.RequestProject.filter(item => item.perid == staff_I.perid && item.Project_code == this.projectData[0].Project_code && item.D_project_round_id == this.ProjectRound[0].id).length > 0) {
                                CheckDupe = true
                              }
                            }
                          }
                          if (!CheckDupe) {
                            this.clearRequestRegister(this.projectData[0].Project_code, (this.ProjectRound.length > 0 ? this.ProjectRound[0].id : ''), this.staffSel).then(resClear => {
                              if (resClear) {
                                this.insertDataToDB({
                                  Project_code: this.projectData[0].Project_code,
                                  D_project_round_id: (this.ProjectRound.length > 0 ? this.ProjectRound[0].id : ''),
                                  perid: staff_I.perid,
                                  status_req: '0',
                                  Create_By: this.MeData[0].perid,
                                  Create_Time: 'now()',
                                }).then(res => {
                                  if (res.status) {
                                    this.$swal.fire({
                                      timer: 1500,
                                      showConfirmButton: false,
                                      icon: 'success',
                                      title: 'บันทึกข้อมูลผู้เข้าร่วมโครงการ ' + staff_I.full_Name + ' สำเร็จ!!'
                                    })
                                    if (this.FilePerson.length > 0) {
                                      this.UploadFilesToDb(this.projectData[0].Project_code, (this.ProjectRound.length > 0 ? this.ProjectRound[0].id : ''), staff_I.perid)
                                    }
                                    this.projectDataToTableDump2 = ''
                                    this.staffSel = ''
                                    this.init()
                                  } else {
                                    this.staffSel = ''
                                    this.$swal.fire({
                                      icon: 'error',
                                      title: 'พบข้อผืดพลาด ไม่สามารถบันทึกข้อมูลได้'
                                    })
                                  }
                                })
                              }
                            })
                          } else {
                            this.staffSel = ''
                            this.$swal.fire({
                              icon: 'error',
                              title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                            })
                          }
                        } else {
                          countPerson = 0
                          this.RequestProject.map(reqP => {
                            if (dep_quota.dep_id == reqP.dep_id) {
                              countPerson++
                            }
                          })

                          if ((this.RequestProject.length + (parseInt(this.ProjectQuotaDepCount) - countPerson)) < parseInt(this.projectData[0].Count_Reg)) {
                            if (this.projectData[0].IsRoundStatus == '0') {
                              if (this.RequestProject.filter(item => item.perid == staff_I.perid && item.Project_code == this.projectData[0].Project_code && (item.D_project_round_id == '' || item.D_project_round_id == null)).length > 0) {
                                CheckDupe = true
                              }
                            } else {
                              if (this.ProjectRound.length > 0) {
                                if (this.RequestProject.filter(item => item.perid == staff_I.perid && item.Project_code == this.projectData[0].Project_code && item.D_project_round_id == this.ProjectRound[0].id).length > 0) {
                                  CheckDupe = true
                                }
                              }
                            }

                            if (!CheckDupe) {
                              this.clearRequestRegister(this.projectData[0].Project_code, (this.ProjectRound.length > 0 ? this.ProjectRound[0].id : ''), this.staffSel).then(resClear => {
                                if (resClear) {
                                  this.insertDataToDB({
                                    Project_code: this.projectData[0].Project_code,
                                    D_project_round_id: (this.ProjectRound.length > 0 ? this.ProjectRound[0].id : ''),
                                    perid: staff_I.perid,
                                    status_req: '0',
                                    Create_By: this.MeData[0].perid,
                                    Create_Time: 'now()',
                                  }).then(res => {
                                    if (res.status) {
                                      this.$swal.fire({
                                        timer: 1500,
                                        showConfirmButton: false,
                                        icon: 'success',
                                        title: 'บันทึกข้อมูลผู้เข้าร่วมโครงการ ' + staff_I.full_Name + ' สำเร็จ!!'
                                      })
                                      if (this.FilePerson.length > 0) {
                                        this.UploadFilesToDb(this.projectData[0].Project_code, (this.ProjectRound.length > 0 ? this.ProjectRound[0].id : ''), staff_I.perid)
                                      }
                                      this.projectDataToTableDump2 = ''
                                      this.staffSel = ''
                                      this.init()
                                    } else {
                                      this.staffSel = ''
                                      this.$swal.fire({
                                        icon: 'error',
                                        title: 'พบข้อผืดพลาด ไม่สามารถบันทึกข้อมูลได้'
                                      })
                                    }
                                  })
                                }
                              })
                            } else {
                              this.staffSel = ''
                              this.$swal.fire({
                                icon: 'error',
                                title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                              })
                            }
                          } else {
                            this.staffSel = ''
                            this.$swal.fire({
                              icon: 'error',
                              title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากหมดโควต้าบุคลกรทั่วไปที่ไม่อยู่ภายใต้เงื่อนไข'
                            })
                          }
                        }
                      }
                    }
                  } else {
                    //// ตรงนี้ต้องเช็ค
                    if (!CheckDepMatch) {
                      var DepGroup = this.depart.filter(item => item.dep_group_id == dep_quota.dep_id)
                      if (DepGroup.length > 0) {
                        if (DepGroup.filter(item => item.dep_id == staff_I.dep_id).length > 0) {
                          CheckDepMatch = true
                          if (this.RequestProject.length > 0) {
                            if (this.RequestProject.filter(item => item.dep_group_id == staff_I.dep_group_id && item.status_req != '2').length < parseInt(dep_quota.count)) {
                              if (this.projectData[0].IsRoundStatus == '0') {
                                if (this.RequestProject.filter(item => item.perid == staff_I.perid && item.Project_code == this.projectData[0].Project_code && (item.D_project_round_id == '' || item.D_project_round_id == null)).length > 0) {
                                  CheckDupe = true
                                }
                              } else {
                                if (this.ProjectRound.length > 0) {
                                  if (this.RequestProject.filter(item => item.perid == staff_I.perid && item.Project_code == this.projectData[0].Project_code && item.D_project_round_id == this.ProjectRound[0].id).length > 0) {
                                    CheckDupe = true
                                  }
                                }
                              }
                              if (!CheckDupe) {
                                this.clearRequestRegister(this.projectData[0].Project_code, (this.ProjectRound.length > 0 ? this.ProjectRound[0].id : ''), this.staffSel).then(resClear => {
                                  if (resClear) {
                                    this.insertDataToDB({
                                      Project_code: this.projectData[0].Project_code,
                                      D_project_round_id: (this.ProjectRound.length > 0 ? this.ProjectRound[0].id : ''),
                                      perid: staff_I.perid,
                                      status_req: '0',
                                      Create_By: this.MeData[0].perid,
                                      Create_Time: 'now()',
                                    }).then(res => {
                                      if (res.status) {
                                        this.$swal.fire({
                                          timer: 1500,
                                          showConfirmButton: false,
                                          icon: 'success',
                                          title: 'บันทึกข้อมูลผู้เข้าร่วมโครงการ ' + staff_I.full_Name + ' สำเร็จ!!'
                                        })
                                        if (this.FilePerson.length > 0) {
                                          this.UploadFilesToDb(this.projectData[0].Project_code, (this.ProjectRound.length > 0 ? this.ProjectRound[0].id : ''), staff_I.perid)
                                        }
                                        this.projectDataToTableDump2 = ''
                                        this.staffSel = ''
                                        this.init()
                                      } else {
                                        this.staffSel = ''
                                        this.$swal.fire({
                                          icon: 'error',
                                          title: 'พบข้อผืดพลาด ไม่สามารถบันทึกข้อมูลได้'
                                        })
                                      }
                                    })
                                  }
                                })
                              } else {
                                this.staffSel = ''
                                this.$swal.fire({
                                  icon: 'error',
                                  title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                                })
                              }
                            } else {
                              this.staffSel = ''
                              this.$swal.fire({
                                icon: 'error',
                                title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากจำนวนผู้เข้าร่วมของ(กลุ่มหน่วยงาน/กลุ่มภาควิชา) ' + staff_I.dep_name + ' เกินกำหนดที่ตั้งไว้'
                              })
                            }
                          } else {
                            // ทำอะไรสักอย่างตรงนี้
                            this.clearRequestRegister(this.projectData[0].Project_code, (this.ProjectRound.length > 0 ? this.ProjectRound[0].id : ''), this.staffSel).then(resClear => {
                              if (resClear) {
                                this.insertDataToDB({
                                  Project_code: this.projectData[0].Project_code,
                                  D_project_round_id: (this.ProjectRound.length > 0 ? this.ProjectRound[0].id : ''),
                                  perid: staff_I.perid,
                                  status_req: '0',
                                  Create_By: this.MeData[0].perid,
                                  Create_Time: 'now()',
                                }).then(res => {
                                  if (res.status) {
                                    this.$swal.fire({
                                      timer: 1500,
                                      showConfirmButton: false,
                                      icon: 'success',
                                      title: 'บันทึกข้อมูลผู้เข้าร่วมโครงการ ' + staff_I.full_Name + ' สำเร็จ!!'
                                    })
                                    if (this.FilePerson.length > 0) {
                                      this.UploadFilesToDb(this.projectData[0].Project_code, (this.ProjectRound.length > 0 ? this.ProjectRound[0].id : ''), staff_I.perid)
                                    }
                                    this.projectDataToTableDump2 = ''
                                    this.staffSel = ''
                                    this.init()
                                  } else {
                                    this.staffSel = ''
                                    this.$swal.fire({
                                      icon: 'error',
                                      title: 'พบข้อผืดพลาด ไม่สามารถบันทึกข้อมูลได้'
                                    })
                                  }
                                })
                              }
                            })
                          }
                        } else {
                          countPerson = 0
                          this.RequestProject.map(reqP => {
                            if (DepGroup.filter(item => item.dep_id == reqP.dep_id).length > 0) {
                              countPerson++
                            }
                          })

                          if ((this.RequestProject.length + (parseInt(this.ProjectQuotaDepCount) - countPerson)) < parseInt(this.projectData[0].Count_Reg)) {
                            if (this.projectData[0].IsRoundStatus == '0') {
                              if (this.RequestProject.filter(item => item.perid == staff_I.perid && item.Project_code == this.projectData[0].Project_code && (item.D_project_round_id == '' || item.D_project_round_id == null)).length > 0) {
                                CheckDupe = true
                              }
                            } else {
                              if (this.ProjectRound.length > 0) {
                                if (this.RequestProject.filter(item => item.perid == staff_I.perid && item.Project_code == this.projectData[0].Project_code && item.D_project_round_id == this.ProjectRound[0].id).length > 0) {
                                  CheckDupe = true
                                }
                              }
                            }
                            if (!CheckDupe) {
                              this.clearRequestRegister(this.projectData[0].Project_code, (this.ProjectRound.length > 0 ? this.ProjectRound[0].id : ''), this.staffSel).then(resClear => {
                                if (resClear) {
                                  this.insertDataToDB({
                                    Project_code: this.projectData[0].Project_code,
                                    D_project_round_id: (this.ProjectRound.length > 0 ? this.ProjectRound[0].id : ''),
                                    perid: staff_I.perid,
                                    status_req: '0',
                                    Create_By: this.MeData[0].perid,
                                    Create_Time: 'now()',
                                  }).then(res => {
                                    if (res.status) {
                                      this.$swal.fire({
                                        timer: 1500,
                                        showConfirmButton: false,
                                        icon: 'success',
                                        title: 'บันทึกข้อมูลผู้เข้าร่วมโครงการ ' + staff_I.full_Name + ' สำเร็จ!!'
                                      })
                                      if (this.FilePerson.length > 0) {
                                        this.UploadFilesToDb(this.projectData[0].Project_code, (this.ProjectRound.length > 0 ? this.ProjectRound[0].id : ''), staff_I.perid)
                                      }
                                      this.projectDataToTableDump2 = ''
                                      this.staffSel = ''
                                      this.init()
                                    } else {
                                      this.staffSel = ''
                                      this.$swal.fire({
                                        icon: 'error',
                                        title: 'พบข้อผืดพลาด ไม่สามารถบันทึกข้อมูลได้'
                                      })
                                    }
                                  })
                                }
                              })
                            } else {
                              this.staffSel = ''
                              this.$swal.fire({
                                icon: 'error',
                                title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                              })
                            }
                          } else {
                            this.staffSel = ''
                            this.$swal.fire({
                              icon: 'error',
                              title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากหมดโควต้าบุคลกรทั่วไปที่ไม่อยู่ภายใต้เงื่อนไข'
                            })
                          }
                        }
                      }
                    }
                  }
                })
              } else {
                // if (this.RequestProject.length < parseInt(this.projectData[0].Count_Reg)) {
                if (this.projectData[0].IsRoundStatus == '0') {
                  if (this.RequestProject.filter(item => item.perid == staff_I.perid && item.Project_code == this.projectData[0].Project_code && (item.D_project_round_id == '' || item.D_project_round_id == null)).length > 0) {
                    CheckDupe = true
                  }
                } else {
                  if (this.ProjectRound.length > 0) {
                    if (this.RequestProject.filter(item => item.perid == staff_I.perid && item.Project_code == this.projectData[0].Project_code && item.D_project_round_id == this.ProjectRound[0].id).length > 0) {
                      CheckDupe = true
                    }
                  }
                }
                if (!CheckDupe) {
                  this.clearRequestRegister(this.projectData[0].Project_code, (this.ProjectRound.length > 0 ? this.ProjectRound[0].id : ''), this.staffSel).then(resClear => {
                    if (resClear) {
                      this.insertDataToDB({
                        Project_code: this.projectData[0].Project_code,
                        D_project_round_id: (this.ProjectRound.length > 0 ? this.ProjectRound[0].id : ''),
                        perid: staff_I.perid,
                        status_req: '0',
                        Create_By: this.MeData[0].perid,
                        Create_Time: 'now()',
                      }).then(res => {
                        if (res.status) {
                          this.$swal.fire({
                            timer: 1500,
                            showConfirmButton: false,
                            icon: 'success',
                            title: 'บันทึกข้อมูลผู้เข้าร่วมโครงการ ' + staff_I.full_Name + ' สำเร็จ!!'
                          })
                          if (this.FilePerson.length > 0) {
                            this.UploadFilesToDb(this.projectData[0].Project_code, (this.ProjectRound.length > 0 ? this.ProjectRound[0].id : ''), staff_I.perid)
                          }
                          this.projectDataToTableDump2 = ''
                          this.staffSel = ''
                          this.init()
                        } else {
                          this.staffSel = ''
                          this.$swal.fire({
                            icon: 'error',
                            title: 'พบข้อผืดพลาด ไม่สามารถบันทึกข้อมูลได้'
                          })
                        }
                      })
                    }
                  })
                } else {
                  this.staffSel = ''
                  this.$swal.fire({
                    icon: 'error',
                    title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                  })
                }
                // } else {
                //   this.staffSel = ''
                //   this.$swal.fire({
                //     icon: 'error',
                //     title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากจำนวนผู้เข้าร่วมเกินจำนวนที่โครงการกำหนด'
                //   })
                // }
              }
            } else {
              this.staffSel = ''
              this.$swal.fire({
                icon: 'error',
                title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากเงื่อนไขอายุงานกลุ่มตัวอย่าง ไม่ตรงกับอายุงานของบุคลากรที่เลือก'
              })
            }
          } else if (this.DepQuotaData.length > 0) {
            this.DepQuotaData.map((dep_quota, idx) => {
              if (dep_quota.dep_type == '0' && !CheckDepMatch) {
                if (staff_I.dep_id == dep_quota.dep_id) {
                  CheckDepMatch = true
                  if (this.RequestProject.length > 0) {
                    if (this.RequestProject.filter(item => item.dep_id == staff_I.dep_id && item.status_req != '2').length < parseInt(dep_quota.count)) {
                      if (this.projectData[0].IsRoundStatus == '0') {
                        if (this.RequestProject.filter(item => item.perid == staff_I.perid && item.Project_code == this.projectData[0].Project_code && (item.D_project_round_id == '' || item.D_project_round_id == null)).length > 0) {
                          CheckDupe = true
                        }
                      } else {
                        if (this.ProjectRound.length > 0) {
                          if (this.RequestProject.filter(item => item.perid == staff_I.perid && item.Project_code == this.projectData[0].Project_code && item.D_project_round_id == this.ProjectRound[0].id).length > 0) {
                            CheckDupe = true
                          }
                        }
                      }

                      if (!CheckDupe) {
                        this.clearRequestRegister(this.projectData[0].Project_code, (this.ProjectRound.length > 0 ? this.ProjectRound[0].id : ''), this.staffSel).then(resClear => {
                          if (resClear) {
                            this.insertDataToDB({
                              Project_code: this.projectData[0].Project_code,
                              D_project_round_id: (this.ProjectRound.length > 0 ? this.ProjectRound[0].id : ''),
                              perid: staff_I.perid,
                              status_req: '0',
                              Create_By: this.MeData[0].perid,
                              Create_Time: 'now()',
                            }).then(res => {
                              if (res.status) {
                                this.$swal.fire({
                                  timer: 1500,
                                  showConfirmButton: false,
                                  icon: 'success',
                                  title: 'บันทึกข้อมูลผู้เข้าร่วมโครงการ ' + staff_I.full_Name + ' สำเร็จ!!'
                                })
                                if (this.FilePerson.length > 0) {
                                  this.UploadFilesToDb(this.projectData[0].Project_code, (this.ProjectRound.length > 0 ? this.ProjectRound[0].id : ''), staff_I.perid)
                                }
                                this.projectDataToTableDump2 = ''
                                this.staffSel = ''
                                this.init()
                              } else {
                                this.staffSel = ''
                                this.$swal.fire({
                                  icon: 'error',
                                  title: 'พบข้อผืดพลาด ไม่สามารถบันทึกข้อมูลได้'
                                })
                              }
                            })
                          }
                        })
                      } else {
                        this.staffSel = ''
                        this.$swal.fire({
                          icon: 'error',
                          title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                        })
                      }
                    } else {
                      this.staffSel = ''
                      this.$swal.fire({
                        icon: 'error',
                        title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากจำนวนผู้เข้าร่วมของหน่วยงาน ' + staff_I.dep_name + ' เกินกำหนดที่ตั้งไว้'
                      })
                    }
                  } else {
                    this.clearRequestRegister(this.projectData[0].Project_code, (this.ProjectRound.length > 0 ? this.ProjectRound[0].id : ''), this.staffSel).then(resClear => {
                      if (resClear) {
                        this.insertDataToDB({
                          Project_code: this.projectData[0].Project_code,
                          D_project_round_id: (this.ProjectRound.length > 0 ? this.ProjectRound[0].id : ''),
                          perid: staff_I.perid,
                          status_req: '0',
                          Create_By: this.MeData[0].perid,
                          Create_Time: 'now()',
                        }).then(res => {
                          if (res.status) {
                            this.$swal.fire({
                              timer: 1500,
                              showConfirmButton: false,
                              icon: 'success',
                              title: 'บันทึกข้อมูลผู้เข้าร่วมโครงการ ' + staff_I.full_Name + ' สำเร็จ!!'
                            })
                            if (this.FilePerson.length > 0) {
                              this.UploadFilesToDb(this.projectData[0].Project_code, (this.ProjectRound.length > 0 ? this.ProjectRound[0].id : ''), staff_I.perid)
                            }
                            this.projectDataToTableDump2 = ''
                            this.staffSel = ''
                            this.init()
                          } else {
                            this.staffSel = ''
                            this.$swal.fire({
                              icon: 'error',
                              title: 'พบข้อผืดพลาด ไม่สามารถบันทึกข้อมูลได้'
                            })
                          }
                        })
                      }
                    })
                  }
                } else {
                  if (!CheckDepMatch && idx == this.DepQuotaData.length - 1) {
                    if (this.projectData[0].Status_Count_Reg == '1') {
                      if (this.projectData[0].IsRoundStatus == '0') {
                        if (this.RequestProject.filter(item => item.perid == staff_I.perid && item.Project_code == this.projectData[0].Project_code && (item.D_project_round_id == '' || item.D_project_round_id == null)).length > 0) {
                          CheckDupe = true
                        }
                      } else {
                        if (this.ProjectRound.length > 0) {
                          if (this.RequestProject.filter(item => item.perid == staff_I.perid && item.Project_code == this.projectData[0].Project_code && item.D_project_round_id == this.ProjectRound[0].id).length > 0) {
                            CheckDupe = true
                          }
                        }
                      }
                      if (!CheckDupe) {
                        this.clearRequestRegister(this.projectData[0].Project_code, (this.ProjectRound.length > 0 ? this.ProjectRound[0].id : ''), this.staffSel).then(resClear => {
                          if (resClear) {
                            this.insertDataToDB({
                              Project_code: this.projectData[0].Project_code,
                              D_project_round_id: (this.ProjectRound.length > 0 ? this.ProjectRound[0].id : ''),
                              perid: staff_I.perid,
                              status_req: '0',
                              Create_By: this.MeData[0].perid,
                              Create_Time: 'now()',
                            }).then(res => {
                              if (res.status) {
                                this.$swal.fire({
                                  timer: 1500,
                                  showConfirmButton: false,
                                  icon: 'success',
                                  title: 'บันทึกข้อมูลผู้เข้าร่วมโครงการ ' + staff_I.full_Name + ' สำเร็จ!!'
                                })
                                if (this.FilePerson.length > 0) {
                                  this.UploadFilesToDb(this.projectData[0].Project_code, (this.ProjectRound.length > 0 ? this.ProjectRound[0].id : ''), staff_I.perid)
                                }
                                this.projectDataToTableDump2 = ''
                                this.staffSel = ''
                                this.init()
                              } else {
                                this.staffSel = ''
                                this.$swal.fire({
                                  icon: 'error',
                                  title: 'พบข้อผืดพลาด ไม่สามารถบันทึกข้อมูลได้'
                                })
                              }
                            })
                          }
                        })
                      } else {
                        this.staffSel = ''
                        this.$swal.fire({
                          icon: 'error',
                          title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                        })
                      }
                    } else {
                      countPerson = 0
                      this.RequestProject.map(reqP => {
                        if (dep_quota.dep_id == reqP.dep_id) {
                          countPerson++
                        }
                      })

                      if ((this.RequestProject.length + (parseInt(this.ProjectQuotaDepCount) - countPerson)) < parseInt(this.projectData[0].Count_Reg)) {
                        if (this.projectData[0].IsRoundStatus == '0') {
                          if (this.RequestProject.filter(item => item.perid == staff_I.perid && item.Project_code == this.projectData[0].Project_code && (item.D_project_round_id == '' || item.D_project_round_id == null)).length > 0) {
                            CheckDupe = true
                          }
                        } else {
                          if (this.ProjectRound.length > 0) {
                            if (this.RequestProject.filter(item => item.perid == staff_I.perid && item.Project_code == this.projectData[0].Project_code && item.D_project_round_id == this.ProjectRound[0].id).length > 0) {
                              CheckDupe = true
                            }
                          }
                        }
                        if (!CheckDupe) {
                          this.clearRequestRegister(this.projectData[0].Project_code, (this.ProjectRound.length > 0 ? this.ProjectRound[0].id : ''), this.staffSel).then(resClear => {
                            if (resClear) {
                              this.insertDataToDB({
                                Project_code: this.projectData[0].Project_code,
                                D_project_round_id: (this.ProjectRound.length > 0 ? this.ProjectRound[0].id : ''),
                                perid: staff_I.perid,
                                status_req: '0',
                                Create_By: this.MeData[0].perid,
                                Create_Time: 'now()',
                              }).then(res => {
                                if (res.status) {
                                  this.$swal.fire({
                                    timer: 1500,
                                    showConfirmButton: false,
                                    icon: 'success',
                                    title: 'บันทึกข้อมูลผู้เข้าร่วมโครงการ ' + staff_I.full_Name + ' สำเร็จ!!'
                                  })
                                  if (this.FilePerson.length > 0) {
                                    this.UploadFilesToDb(this.projectData[0].Project_code, (this.ProjectRound.length > 0 ? this.ProjectRound[0].id : ''), staff_I.perid)
                                  }
                                  this.projectDataToTableDump2 = ''
                                  this.staffSel = ''
                                  this.init()
                                } else {
                                  this.staffSel = ''
                                  this.$swal.fire({
                                    icon: 'error',
                                    title: 'พบข้อผืดพลาด ไม่สามารถบันทึกข้อมูลได้'
                                  })
                                }
                              })
                            }
                          })
                        } else {
                          this.staffSel = ''
                          this.$swal.fire({
                            icon: 'error',
                            title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                          })
                        }
                      } else {
                        this.staffSel = ''
                        this.$swal.fire({
                          icon: 'error',
                          title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากหมดโควต้าบุคลกรทั่วไปที่ไม่อยู่ภายใต้เงื่อนไข'
                        })
                      }
                    }
                  }
                }
              } else {
                //// ตรงนี้ต้องเช็ค
                if (!CheckDepMatch) {
                  var DepGroup = this.depart.filter(item => item.dep_group_id == dep_quota.dep_id)
                  if (DepGroup.length > 0) {
                    if (DepGroup.filter(item => item.dep_id == staff_I.dep_id).length > 0) {
                      CheckDepMatch = true
                      if (this.RequestProject.length > 0) {
                        if (this.RequestProject.filter(item => item.dep_group_id == staff_I.dep_group_id && item.status_req != '2').length < parseInt(dep_quota.count)) {
                          if (this.projectData[0].IsRoundStatus == '0') {
                            if (this.RequestProject.filter(item => item.perid == staff_I.perid && item.Project_code == this.projectData[0].Project_code && (item.D_project_round_id == '' || item.D_project_round_id == null)).length > 0) {
                              CheckDupe = true
                            }
                          } else {
                            if (this.ProjectRound.length > 0) {
                              if (this.RequestProject.filter(item => item.perid == staff_I.perid && item.Project_code == this.projectData[0].Project_code && item.D_project_round_id == this.ProjectRound[0].id).length > 0) {
                                CheckDupe = true
                              }
                            }
                          }
                          if (!CheckDupe) {
                            this.clearRequestRegister(this.projectData[0].Project_code, (this.ProjectRound.length > 0 ? this.ProjectRound[0].id : ''), this.staffSel).then(resClear => {
                              if (resClear) {
                                this.insertDataToDB({
                                  Project_code: this.projectData[0].Project_code,
                                  D_project_round_id: (this.ProjectRound.length > 0 ? this.ProjectRound[0].id : ''),
                                  perid: staff_I.perid,
                                  status_req: '0',
                                  Create_By: this.MeData[0].perid,
                                  Create_Time: 'now()',
                                }).then(res => {
                                  if (res.status) {
                                    this.$swal.fire({
                                      timer: 1500,
                                      showConfirmButton: false,
                                      icon: 'success',
                                      title: 'บันทึกข้อมูลผู้เข้าร่วมโครงการ ' + staff_I.full_Name + ' สำเร็จ!!'
                                    })
                                    if (this.FilePerson.length > 0) {
                                      this.UploadFilesToDb(this.projectData[0].Project_code, (this.ProjectRound.length > 0 ? this.ProjectRound[0].id : ''), staff_I.perid)
                                    }
                                    this.projectDataToTableDump2 = ''
                                    this.staffSel = ''
                                    this.init()
                                  } else {
                                    this.$swal.fire({
                                      icon: 'error',
                                      title: 'พบข้อผืดพลาด ไม่สามารถบันทึกข้อมูลได้'
                                    })
                                  }
                                })
                              }
                            })
                          } else {
                            this.staffSel = ''
                            this.$swal.fire({
                              icon: 'error',
                              title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                            })
                          }
                        } else {
                          this.staffSel = ''
                          this.$swal.fire({
                            icon: 'error',
                            title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากจำนวนผู้เข้าร่วมของ(กลุ่มหน่วยงาน/กลุ่มภาควิชา) ' + staff_I.dep_name + ' เกินกำหนดที่ตั้งไว้'
                          })
                        }
                      } else {
                        //// ทำอะไรสักอย่างตรงนี้
                        this.clearRequestRegister(this.projectData[0].Project_code, (this.ProjectRound.length > 0 ? this.ProjectRound[0].id : ''), this.staffSel).then(resClear => {
                          if (resClear) {
                            this.insertDataToDB({
                              Project_code: this.projectData[0].Project_code,
                              D_project_round_id: (this.ProjectRound.length > 0 ? this.ProjectRound[0].id : ''),
                              perid: staff_I.perid,
                              status_req: '0',
                              Create_By: this.MeData[0].perid,
                              Create_Time: 'now()',
                            }).then(res => {
                              if (res.status) {
                                this.$swal.fire({
                                  timer: 1500,
                                  showConfirmButton: false,
                                  icon: 'success',
                                  title: 'บันทึกข้อมูลผู้เข้าร่วมโครงการ ' + staff_I.full_Name + ' สำเร็จ!!'
                                })
                                if (this.FilePerson.length > 0) {
                                  this.UploadFilesToDb(this.projectData[0].Project_code, (this.ProjectRound.length > 0 ? this.ProjectRound[0].id : ''), staff_I.perid)
                                }
                                this.projectDataToTableDump2 = ''
                                this.staffSel = ''
                                this.init()
                              } else {
                                this.staffSel = ''
                                this.$swal.fire({
                                  icon: 'error',
                                  title: 'พบข้อผืดพลาด ไม่สามารถบันทึกข้อมูลได้'
                                })
                              }
                            })
                          }
                        })
                      }
                    } else {
                      countPerson = 0
                      this.RequestProject.map(reqP => {
                        if (DepGroup.filter(item => item.dep_id == reqP.dep_id).length > 0) {
                          countPerson++
                        }
                      })

                      // if ((this.RequestProject.length + (parseInt(this.ProjectQuotaDepCount) - countPerson)) < parseInt(this.projectData[0].Count_Reg)) {
                      if (this.projectData[0].IsRoundStatus == '0') {
                        if (this.RequestProject.filter(item => item.perid == staff_I.perid && item.Project_code == this.projectData[0].Project_code && (item.D_project_round_id == '' || item.D_project_round_id == null)).length > 0) {
                          CheckDupe = true
                        }
                      } else {
                        if (this.ProjectRound.length > 0) {
                          if (this.RequestProject.filter(item => item.perid == staff_I.perid && item.Project_code == this.projectData[0].Project_code && item.D_project_round_id == this.ProjectRound[0].id).length > 0) {
                            CheckDupe = true
                          }
                        }
                      }
                      if (!CheckDupe) {
                        this.clearRequestRegister(this.projectData[0].Project_code, (this.ProjectRound.length > 0 ? this.ProjectRound[0].id : ''), this.staffSel).then(resClear => {
                          if (resClear) {
                            this.insertDataToDB({
                              Project_code: this.projectData[0].Project_code,
                              D_project_round_id: (this.ProjectRound.length > 0 ? this.ProjectRound[0].id : ''),
                              perid: staff_I.perid,
                              status_req: '0',
                              Create_By: this.MeData[0].perid,
                              Create_Time: 'now()',
                            }).then(res => {
                              if (res.status) {
                                this.$swal.fire({
                                  timer: 1500,
                                  showConfirmButton: false,
                                  icon: 'success',
                                  title: 'บันทึกข้อมูลผู้เข้าร่วมโครงการ ' + staff_I.full_Name + ' สำเร็จ!!'
                                })
                                if (this.FilePerson.length > 0) {
                                  this.UploadFilesToDb(this.projectData[0].Project_code, (this.ProjectRound.length > 0 ? this.ProjectRound[0].id : ''), staff_I.perid)
                                }
                                this.projectDataToTableDump2 = ''
                                this.staffSel = ''
                                this.init()
                              } else {
                                this.staffSel = ''
                                this.$swal.fire({
                                  icon: 'error',
                                  title: 'พบข้อผืดพลาด ไม่สามารถบันทึกข้อมูลได้'
                                })
                              }
                            })
                          }
                        })
                      } else {
                        this.staffSel = ''
                        this.$swal.fire({
                          icon: 'error',
                          title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                        })
                      }
                      // } else {
                      //   this.staffSel = ''
                      //   this.$swal.fire({
                      //     icon: 'error',
                      //     title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากหมดโควต้าบุคลกรทั่วไปที่ไม่อยู่ภายใต้เงื่อนไข'
                      //   })
                      // }
                    }
                  }
                }
              }
            })
          } else {
            if (this.projectData[0].IsRoundStatus == '0') {
              if (this.RequestProject.filter(item => item.perid == staff_I.perid && item.Project_code == this.projectData[0].Project_code && (item.D_project_round_id == '' || item.D_project_round_id == null)).length > 0) {
                CheckDupe = true
              }
            } else {
              if (this.ProjectRound.length > 0) {
                if (this.RequestProject.filter(item => item.perid == staff_I.perid && item.Project_code == this.projectData[0].Project_code && item.D_project_round_id == this.ProjectRound[0].id).length > 0) {
                  CheckDupe = true
                }
              }
            }
            if (!CheckDupe) {
              // var CheckLimitReg = (this.projectData[0].IsRoundStatus == '0') ? (this.projectData[0].Status_Count_Reg == '0' ? (this.RequestProject.length < parseInt(this.projectData[0].Count_Reg)? false : true) : false) : (this.ProjectRound[0].Status_Count_Reg == '0' ? (this.RequestProject.length < parseInt(this.ProjectRound[0].Count_Reg)? false : true) : false)

              // if (!CheckLimitReg){
              this.clearRequestRegister(this.projectData[0].Project_code, (this.ProjectRound.length > 0 ? this.ProjectRound[0].id : ''), this.staffSel).then(resClear => {
                if (resClear) {
                  this.insertDataToDB({
                    Project_code: this.projectData[0].Project_code,
                    D_project_round_id: (this.ProjectRound.length > 0 ? this.ProjectRound[0].id : ''),
                    perid: staff_I.perid,
                    status_req: '0',
                    Create_By: this.MeData[0].perid,
                    Create_Time: 'now()',
                  }).then(res => {
                    if (res.status) {
                      this.$swal.fire({
                        timer: 1500,
                        showConfirmButton: false,
                        icon: 'success',
                        title: 'บันทึกข้อมูลผู้เข้าร่วมโครงการ ' + staff_I.full_Name + ' สำเร็จ!!'
                      })
                      if (this.FilePerson.length > 0) {
                        this.UploadFilesToDb(this.projectData[0].Project_code, (this.ProjectRound.length > 0 ? this.ProjectRound[0].id : ''), staff_I.perid)
                      }
                      this.projectDataToTableDump2 = ''
                      this.staffSel = ''
                      this.init()
                    } else {
                      this.staffSel = ''
                      this.$swal.fire({
                        icon: 'error',
                        title: 'พบข้อผืดพลาด ไม่สามารถบันทึกข้อมูลได้'
                      })
                    }
                  })
                }
              })
              // } else {
              //   this.staffSel = ''
              //   this.$swal.fire({
              //     icon: 'error',
              //     title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากหมดโควต้าบุคลกรทั่วไปที่ไม่อยู่ภายใต้เงื่อนไข'
              //   })
              // }
            } else {
              this.staffSel = ''
              this.$swal.fire({
                icon: 'error',
                title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
              })
            }
          }
        }
      })
    },
    clearRequestRegister(ProjectCode, RoundUID, perid) {
      return new Promise(resolve => {
        if (RoundUID == '') {
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/request_project/Project_code/' + ProjectCode + '/perid/' + perid, {
            active: '0',
            update_by: this.MeData[0].perid
          }).then(res => {
            if (res.data.status) {
              resolve(true)
            } else {
              resolve(true)
            }
          }).catch(resCatch => {
            if (resCatch) {
              resolve(true)
            }
          })
        } else {
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/request_project/Project_code/' + ProjectCode + '/D_project_round_id/' + RoundUID + '/perid/' + perid, {
            active: '0',
            update_by: this.MeData[0].perid
          }).then(res => {
            if (res.data.status) {
              resolve(true)
            } else {
              resolve(true)
            }
          }).catch(resCatch => {
            if (resCatch) {
              resolve(true)
            }
          })
        }
      })
    },
    insertDataToDB(RegObj) {
      return new Promise(resolve => {
        const headerAxios = {
          headers: {
            'Content-Type': 'application/json',
            'X-REST-METHOD': 'PUT'
          }
        }
        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/request_project', RegObj, headerAxios).then(res => {
          if (res.data.status) {
            axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/request_project/Project_code/' + RegObj.Project_code + '/perid/' + RegObj.perid + '/?limit=1', '', headerAxios).then(resGet => {
              resolve({
                status: true,
                data: resGet.data
              })
            })
          } else {
            resolve({
              status: false,
              data: ''
            })
          }
        })
      })
    },
    DaysInMonth(anyDateInMonth) {
      return new Date(anyDateInMonth.getFullYear(),
          anyDateInMonth.getMonth() + 1,
          0).getDate()
    },
    getAge(date_1, date_2) {
      //convert to UTC
      var arrayWorkSummary = [];
      var date2_UTC = new Date(Date.UTC(date_2.getUTCFullYear(), date_2.getUTCMonth(), date_2.getUTCDate()));
      var date1_UTC = new Date(Date.UTC(date_1.getUTCFullYear(), date_1.getUTCMonth(), date_1.getUTCDate()));


      //--------------------------------------------------------------
      var days = date2_UTC.getDate() - date1_UTC.getDate();
      if (days < 0) {

        date2_UTC.setMonth(date2_UTC.getMonth() - 1);
        days += this.DaysInMonth(date2_UTC);
      }
      //--------------------------------------------------------------
      var months = date2_UTC.getMonth() - date1_UTC.getMonth();
      if (months < 0) {
        date2_UTC.setFullYear(date2_UTC.getFullYear() - 1);
        months += 12;
      }
      //--------------------------------------------------------------
      var years = date2_UTC.getFullYear() - date1_UTC.getFullYear();

      arrayWorkSummary.push(years);
      arrayWorkSummary.push(months);
      arrayWorkSummary.push(days);

      return arrayWorkSummary;
    },
    GetDateNow() {
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = today.getFullYear();

      return yyyy + '-' + mm + '-' + dd;
    },
    formatDateNow() {
      var d = new Date(),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();

      if (month.length < 2)
        month = '0' + month;
      if (day.length < 2)
        day = '0' + day;

      return [year, month, day].join('-');
    },
    ShowCordiProject() {
      this.dialogLoading = true
      this.QoutaDepDataDump = []
      this.DepQuotaData = []
      this.ProjectQuotaDepCount = 0
      this.GroupExamData = []

      this.QoutaDepDataDump = this.UniqueArraybyId(this.QuotaDepart, 'id')
      if (this.projectData[0].IsRoundStatus == '0') {
        this.QoutaDepDataDump = this.QoutaDepDataDump.filter(item => item.Project_code == this.projectData[0].Project_code)
      } else {
        if (this.ProjectRound.length > 0) {
          this.QoutaDepDataDump = this.QoutaDepDataDump.filter(item => item.Project_code == this.projectData[0].Project_code && item.D_project_round_id == this.ProjectRound[0].id)
        }
      }
      if (this.QoutaDepDataDump.length > 0) {
        this.QoutaDepDataDump.map(DepQ => {
          this.ProjectQuotaDepCount += parseInt(DepQ.count)
        })
        this.DepQuotaData = this.QoutaDepDataDump
      }

      this.initGroupExamProject({
        Project_code: this.projectData[0].Project_code
      }).then(resGroup => {
        if (resGroup) {
          if (this.projectData[0].IsRoundStatus == '0') {
            this.GroupExamData = this.GroupExamProject
          } else {
            if (this.ProjectRound.length > 0) {
              var GroupExDump = this.GroupExamProject.filter(GroupI => GroupI.D_project_round_id == this.ProjectRound[0].id)
              if (GroupExDump.length > 0) {
                this.GroupExamData = GroupExDump
              }
            }
          }
        }
        this.dialogDetail = true
        this.dialogLoading = false
      }).catch(res => {
        if (res) {
          this.dialogDetail = true
          this.dialogLoading = false
        }
      })
    },
    UniqueArraybyId(collection, keyname) {
      var output = [],
          keys = [];

      collection.map((item) => {
        var key = item[keyname];
        if (keys.indexOf(key) === -1) {
          keys.push(key);
          output.push(item);
        }
      });
      return output;
    }
  },
  mounted() {
    this.dialogLoading = true
    this.saveSessions({
      session: ConstData.ConnectionHostHrTrain + this.$route.fullPath
    })
    this.initMeData().then(res => {
      if (res) {
        this.dialogLoading = false
        this.init()
      }
    }).catch(reason => {
      console.log('Reject = ' + reason)
    })
  }
}
</script>

<style scoped>

</style>
